// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../images/font-awesome/exclamation-triangle.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../images/expand-link.png");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../images/add-to-filter.png");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../images/direction-in.png");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../images/direction-out.png");
var ___CSS_LOADER_URL_IMPORT_5___ = require("../images/font-awesome/times-circle-regular.svg");
var ___CSS_LOADER_URL_IMPORT_6___ = require("../images/connections.svg");
var ___CSS_LOADER_URL_IMPORT_7___ = require("../images/close-connections.svg");
var ___CSS_LOADER_URL_IMPORT_8___ = require("../images/link.svg");
var ___CSS_LOADER_URL_IMPORT_9___ = require("../images/delete.svg");
var ___CSS_LOADER_URL_IMPORT_10___ = require("../images/expand-properties.png");
var ___CSS_LOADER_URL_IMPORT_11___ = require("../images/collapse-properties.png");
var ___CSS_LOADER_URL_IMPORT_12___ = require("../images/font-awesome/undo-solid.svg");
var ___CSS_LOADER_URL_IMPORT_13___ = require("../images/font-awesome/plug.svg");
var ___CSS_LOADER_URL_IMPORT_14___ = require("../images/font-awesome/edit.svg");
var ___CSS_LOADER_URL_IMPORT_15___ = require("../images/font-awesome/trash-alt.svg");
var ___CSS_LOADER_URL_IMPORT_16___ = require("../images/font-awesome/pen-square-solid.svg");
var ___CSS_LOADER_URL_IMPORT_17___ = require("../images/font-awesome/minus-square-regular.svg");
var ___CSS_LOADER_URL_IMPORT_18___ = require("../images/font-awesome/plus-square-regular.svg");
var ___CSS_LOADER_URL_IMPORT_19___ = require("../images/arrow-left.png");
var ___CSS_LOADER_URL_IMPORT_20___ = require("../images/arrow-left1.png");
var ___CSS_LOADER_URL_IMPORT_21___ = require("../images/arrow-right.png");
var ___CSS_LOADER_URL_IMPORT_22___ = require("../images/arrow-right1.png");
var ___CSS_LOADER_URL_IMPORT_23___ = require("../images/resizable-column-handle.png");
var ___CSS_LOADER_URL_IMPORT_24___ = require("../images/arrow-top.png");
var ___CSS_LOADER_URL_IMPORT_25___ = require("../images/arrow-top1.png");
var ___CSS_LOADER_URL_IMPORT_26___ = require("../images/arrow-bottom.png");
var ___CSS_LOADER_URL_IMPORT_27___ = require("../images/arrow-bottom1.png");
var ___CSS_LOADER_URL_IMPORT_28___ = require("../images/left-panel.svg");
var ___CSS_LOADER_URL_IMPORT_29___ = require("../images/right-panel.svg");
var ___CSS_LOADER_URL_IMPORT_30___ = require("../images/left-panel-active.svg");
var ___CSS_LOADER_URL_IMPORT_31___ = require("../images/right-panel-active.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-explorer-spinner__arrow {
  animation-name: graph-explorer-spinner-rotation;
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-iteration-count: infinite;
}
.graph-explorer-spinner[data-error=true] .graph-explorer-spinner__arrow {
  animation-iteration-count: 1;
}

@keyframes graph-explorer-spinner-rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.clearfix:before, .clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.graph-explorer-label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}

.graph-explorer-btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  text-transform: none;
  transition: background-color 0.3s;
}
.graph-explorer-btn[disabled] {
  cursor: not-allowed;
  opacity: 0.65;
}

.graph-explorer-btn-default {
  background-color: #fff;
  border-color: #ccc;
  color: #333;
}
.graph-explorer-btn-default:hover {
  background-color: #e0e0e0;
}
.graph-explorer-btn-default.active {
  background-color: #e0e0e0;
  border-color: #dbdbdb;
}
.graph-explorer-btn-default.active:hover {
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}
.graph-explorer-btn-default[disabled], .graph-explorer-btn-default[disabled]:hover, .graph-explorer-btn-default[disabled].active, .graph-explorer-btn-default[disabled].active:hover {
  background-color: #e0e0e0;
}

.graph-explorer-btn-primary {
  color: rgb(255, 255, 255);
  background-color: rgb(51, 122, 183);
  border-color: #245580;
}
.graph-explorer-btn-primary:hover, .graph-explorer-btn-primary:focus, .graph-explorer-btn-primary:active {
  background-color: #265a88;
}
.graph-explorer-btn-primary:hover, .graph-explorer-btn-primary:focus {
  border-color: #204d74;
}
.graph-explorer-btn-primary.active {
  border-color: #245580;
}
.graph-explorer-btn-primary[disabled], .graph-explorer-btn-primary[disabled]:hover, .graph-explorer-btn-primary[disabled]:focus, .graph-explorer-btn-primary[disabled]:active, .graph-explorer-btn-primary[disabled].active {
  background-color: #265a88;
}

.graph-explorer-btn-success {
  background-color: #5cb85c;
  border-color: #5cb85c;
  color: #fff;
  transition: 0.3s;
}
.graph-explorer-btn-success:hover {
  background: rgb(71.3641025641, 163.8358974359, 71.3641025641);
}

.graph-explorer-btn-danger {
  background-color: #c9302c;
  border-color: #c9302c;
  color: #fff;
  transition: 0.3s;
}
.graph-explorer-btn-danger:hover {
  background: rgb(167.5273469388, 40.0065306122, 36.6726530612);
}

.graph-explorer-btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.graph-explorer-btn-group > .graph-explorer-btn, .graph-explorer-btn-group > .graph-explorer-btn-group {
  position: relative;
  float: left;
}
.graph-explorer-btn-group > .graph-explorer-btn:hover,
.graph-explorer-btn-group > .graph-explorer-btn:focus,
.graph-explorer-btn-group > .graph-explorer-btn.active,
.graph-explorer-btn-group > .graph-explorer-btn.active:hover {
  z-index: 2;
}
.graph-explorer-btn-group .graph-explorer-btn + .graph-explorer-btn,
.graph-explorer-btn-group .graph-explorer-btn + .graph-explorer-btn-group,
.graph-explorer-btn-group .graph-explorer-btn-group + .graph-explorer-btn,
.graph-explorer-btn-group .graph-explorer-btn-group + .graph-explorer-btn-group {
  margin-left: -1px;
}
.graph-explorer-btn-group > .graph-explorer-btn:first-child {
  margin-left: 0;
}
.graph-explorer-btn-group-sm > .graph-explorer-btn {
  font-size: 12px;
  line-height: 1.5;
  padding: 5px 10px;
}
.graph-explorer-btn-group-xs > .graph-explorer-btn {
  font-size: 12px;
  line-height: 1.5;
  padding: 1px 5px;
}

.graph-explorer-form-control {
  display: block;
  width: 100%;
  height: 34px;
  margin: 0;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background: #fff;
  border: 1px solid #ccc;
  transition: border-color ease-in-out 0.15s;
}
.graph-explorer-form-control:focus {
  border-color: #66afe9;
  outline: 0;
}
.graph-explorer-form-control:disabled {
  background-color: #eee;
  cursor: not-allowed;
  opacity: 0.6;
}

.graph-explorer-input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.graph-explorer-input-group .graph-explorer-form-control {
  display: table-cell;
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
}
.graph-explorer-input-group .graph-explorer-form-control:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.graph-explorer-input-group-btn {
  display: table-cell;
  width: 1%;
  vertical-align: middle;
  position: relative;
  font-size: 0;
  white-space: nowrap;
}
.graph-explorer-input-group-btn:last-child > .graph-explorer-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 2;
  margin-left: -1px;
}

.graph-explorer-list-group {
  margin: 0;
  padding: 0;
}

.graph-explorer-list-group-item:last-child {
  margin-bottom: 0;
}

.graph-explorer-list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.graph-explorer-badge {
  display: inline-block;
  min-width: 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: rgb(255, 255, 255);
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: rgb(119, 119, 119);
  padding: 3px 7px;
  border-radius: 10px;
}

.graph-explorer-overlayed-element {
  cursor: move;
  outline: none;
}

.graph-explorer-overlayed-element,
.graph-explorer-exported-element {
  box-sizing: border-box;
  color: black;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
}
.graph-explorer-overlayed-element img,
.graph-explorer-exported-element img {
  vertical-align: middle;
}

.graph-explorer-exported-element *, .graph-explorer-exported-element *:before, .graph-explorer-exported-element *:after {
  box-sizing: inherit;
}

.graph-explorer-overlayed-element--blurred {
  filter: grayscale(100%);
  opacity: 0.5;
}

.graph-explorer-link__wrap {
  stroke-width: 12px;
  stroke-linejoin: round;
  stroke-linecap: round;
  stroke: transparent;
  fill: none;
}
.graph-explorer-link:hover .graph-explorer-link__wrap {
  stroke: rgba(140, 140, 140, 0.44);
}
.graph-explorer-link__vertex {
  cursor: all-scroll;
}
.graph-explorer-link:not(:hover) .graph-explorer-link__vertex {
  fill: transparent;
}
.graph-explorer-link__vertex-tools {
  opacity: 0;
  cursor: pointer;
}
.graph-explorer-link__vertex-tools > circle {
  fill: gray;
}
.graph-explorer-link__vertex-tools > path {
  stroke: white;
}
.graph-explorer-link__vertex-tools:hover > circle {
  fill: black;
}
.graph-explorer-link:hover .graph-explorer-link__vertex-tools {
  opacity: 0.8;
}
.graph-explorer-link--blurred {
  opacity: 0.5;
}

.graph-explorer-paper-area {
  flex: auto;
  width: 0;
  display: flex;
  position: relative;
  cursor: default;
  background: #fff;
}
.graph-explorer-paper-area__area {
  flex: auto;
  overflow: hidden;
}
.graph-explorer-paper-area__widgets {
  position: absolute;
  left: 0;
  top: 0;
}
.graph-explorer-paper-area__watermark {
  background-size: cover;
  width: 8%;
  max-width: 130px;
  min-width: 50px;
  position: absolute;
  top: 15px;
  right: 25px;
  cursor: pointer;
  opacity: 0.3;
  transition: opacity 0.3s;
}
.graph-explorer-paper-area__watermark:hover {
  opacity: 0.5;
}
.graph-explorer-paper-area--hide-scrollbars {
  overflow: hidden;
}

.graph-explorer-paper {
  position: relative;
}

.graph-explorer-exported-watermark {
  opacity: 0.3;
  transition: opacity 0.3s;
}

.graph-explorer-paper-area--animated .graph-explorer-overlayed-element {
  transition: transform 0.5s ease-in-out;
}
.graph-explorer-paper-area--animated .graph-explorer-link-layer, .graph-explorer-paper-area--animated .graph-explorer-paper-area__widgets {
  transition: none;
  opacity: 0;
}

.graph-explorer-link-layer, .graph-explorer-paper-area__widgets {
  transition: opacity 0.5s ease-in-out;
}

.graph-explorer-loading-widget {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10;
}

.graph-explorer-authoring-state__item-error {
  align-self: flex-end;
  margin: 0px 5px;
  display: flex;
  align-items: center;
  cursor: help;
}
.graph-explorer-authoring-state__item-error-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 15px;
  width: 17px;
}
.graph-explorer-authoring-state__state-label {
  font-weight: bold;
  margin-right: 5px;
}
.graph-explorer-authoring-state__state-cancel {
  color: #3f87a6;
  cursor: pointer;
}
.graph-explorer-authoring-state__state-cancel:hover {
  text-decoration: underline;
}
.graph-explorer-authoring-state__state-indicator {
  position: absolute;
}
.graph-explorer-authoring-state__state-indicator-container {
  position: relative;
}
.graph-explorer-authoring-state__state-indicator-body {
  position: absolute;
  white-space: nowrap;
  display: flex;
  align-items: center;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
}

.graph-explorer-authoring-tools {
  margin: 10px;
}
.graph-explorer-authoring-tools__create-entity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  white-space: normal;
}
.graph-explorer-authoring-tools__type-label {
  color: black;
  border: black 1px dashed;
  background: rgb(255, 210, 33);
  padding: 0 0.5em 0 0.5em;
  word-wrap: break-word;
}

.graph-explorer-class-tree {
  flex: auto;
  display: flex;
  flex-direction: column;
}
.graph-explorer-class-tree__filter {
  flex-shrink: 0;
  margin: 10px 0 10px 0;
}
.graph-explorer-class-tree__filter-group {
  margin-left: 10px;
  margin-right: 10px;
}
.graph-explorer-class-tree__only-creatable {
  display: block;
  margin-top: 5px;
}
.graph-explorer-class-tree__tree {
  border-top: 1px solid rgb(221, 221, 221);
}
.graph-explorer-class-tree__spinner {
  align-self: center;
  /* center vertically in flexbox */
  margin: auto;
}

.graph-explorer-class-leaf {
  margin: 1px 0;
}
.graph-explorer-class-leaf__row {
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
}
.graph-explorer-class-leaf__row > * {
  flex-shrink: 0;
}
.graph-explorer-class-leaf__body {
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 15px;
  padding: 1px;
  border: 1px solid;
  border-color: transparent;
}
.graph-explorer-class-leaf__body:hover {
  background: rgba(220, 235, 255, 0.568627451);
  border-color: #ccefff;
  cursor: pointer;
}
.graph-explorer-class-leaf__body--selected {
  background-color: #beebff;
  border-color: #8edcff;
}
.graph-explorer-class-leaf__icon-container {
  height: 20px;
}
.graph-explorer-class-leaf__icon {
  display: block;
  height: 100%;
}
.graph-explorer-class-leaf__label {
  margin-left: 5px;
  color: black;
}
.graph-explorer-class-leaf__highlighted-term {
  font-weight: bold;
}
.graph-explorer-class-leaf__count {
  margin-left: 5px;
}
.graph-explorer-class-leaf__children {
  margin-left: 20px;
}
.graph-explorer-class-leaf__no-toggle {
  display: inline-block;
  width: 22px;
  height: 22px;
}
.graph-explorer-class-leaf__toggle {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 5px;
}
.graph-explorer-class-leaf__toggle:hover:not(:empty) {
  background: rgba(220, 235, 255, 0.568627451);
  cursor: pointer;
}
.graph-explorer-class-leaf__toggle-icon {
  display: block;
  height: 100%;
}
.graph-explorer-class-leaf__create {
  margin-left: 5px;
}
.graph-explorer-class-leaf__create > button {
  cursor: move;
}

.graph-explorer-connections-menu {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.graph-explorer-connections-menu__sort-switch {
  display: none;
}
.graph-explorer-connections-menu__sort-switch:checked + .graph-explorer-connections-menu__sort-switch-label {
  color: #337ab7;
  opacity: 1;
}
.graph-explorer-connections-menu__sort-switch-label {
  cursor: pointer;
  display: block;
  margin: 0;
  opacity: 0.4;
  text-align: center;
}
.graph-explorer-connections-menu__sort-switch-label:hover {
  opacity: 1;
}
.graph-explorer-connections-menu__search-line-input {
  flex: 1 1 100%;
}

.graph-explorer-connections-menu_bread-crumbs {
  padding: 10px;
  padding-bottom: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 27px;
  min-height: 27px;
  flex-grow: 0;
}

.graph-explorer-connections-menu__title-label {
  position: absolute;
  top: -11px;
  left: 10px;
  background: white;
  padding-left: 3px;
  padding-right: 3px;
  border-radius: 6px;
}

.graph-explorer-connections-menu_search-line {
  padding: 10px;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.graph-explorer-connections-menu_search-line-sort-switches {
  flex: 0 0 20px;
  margin-left: 10px;
}

.graph-explorer-connections-menu_links-list {
  padding: 5px;
  overflow-x: hidden;
  overflow-y: auto;
  border-top: 1px solid #dbdbdb;
  flex-grow: 1;
  margin: 0;
}

.ocm_links-list-empty {
  display: flex;
  align-items: center;
}

.graph-explorer-connections-menu_links-list__empty {
  width: 100%;
  position: relative;
  font-size: x-large;
  color: #cbcbcb;
  text-align: center;
}

.graph-explorer-connections-menu__loading,
.graph-explorer-connections-menu__error {
  width: 100%;
  height: 100%;
  position: relative;
  font-size: x-large;
  display: flex;
  color: #cbcbcb;
  align-items: center;
  justify-content: center;
}

.graph-explorer-connections-menu__loading-objects {
  border: 1px solid gray;
  flex-grow: 1;
  box-shadow: inset 0px 0px 23px -8px gray;
  background-color: whitesmoke;
  position: relative;
  font-size: x-large;
  display: flex;
  color: #cbcbcb;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}

.graph-explorer-connections-menu__move-to-filter {
  display: flex;
  padding: 5px 10px;
  user-select: none;
  cursor: pointer;
}
.graph-explorer-connections-menu__move-to-filter:hover {
  background-color: #e6e6e6;
}

.link-in-popup-menu {
  display: flex;
  overflow: hidden;
  padding: 0 5px 0 0;
  align-items: center;
  margin-bottom: 4px;
  background: #f7f7f7;
}
.link-in-popup-menu__link-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 5px 0px 5px 5px;
}
.link-in-popup-menu__count {
  flex-shrink: 0;
  margin-left: 10px;
}
.link-in-popup-menu__navigate-button {
  float: right;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 16px;
  height: 16px;
  opacity: 0.5;
  margin-left: 10px;
  min-width: 16px;
  background-size: cover;
}
.link-in-popup-menu__navigate-button:hover {
  opacity: 1;
}
.link-in-popup-menu__filter-button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  opacity: 0.4;
  margin-left: 10px;
}
.link-in-popup-menu__filter-button:hover {
  opacity: 1;
}
.link-in-popup-menu:hover {
  background-color: #e2e2e2;
}

.link-in-popup-menu_direction {
  background: rgba(219, 219, 219, 0.35);
  min-height: 30px;
  padding: 5px 0px 5px 10px;
  display: flex;
  align-items: center;
}

.link-in-popup-menu_direction__in-direction {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 0 no-repeat;
  flex-shrink: 0;
  width: 22px;
  height: 15px;
  margin: 0 14px 0 0;
  background-size: contain;
  opacity: 0.5;
}

.link-in-popup-menu_direction__out-direction {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 0 0 no-repeat;
  flex-shrink: 0;
  width: 22px;
  height: 15px;
  margin: 0 8px 0 6px;
  background-size: contain;
  opacity: 0.5;
}

.graph-explorer-connections-menu_links-list__loading {
  text-align: center;
  width: 100%;
  position: relative;
  font-size: x-large;
  color: #cbcbcb;
}

.graph-explorer-connections-menu_links-list__hr {
  margin-top: 10px;
  margin-bottom: 10px;
}

.graph-explorer-connections-menu_objects-panel {
  flex-grow: 1;
  padding: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
}

.graph-explorer-connections-menu_objects-panel__select-all {
  white-space: nowrap;
  margin-bottom: 5px;
  display: flex;
}
.graph-explorer-connections-menu_objects-panel__select-all input {
  margin-right: 5px;
}
.graph-explorer-connections-menu_objects-panel__select-all input:disabled {
  opacity: 0.3;
}

.graph-explorer-connections-menu_objects-panel_bottom-panel {
  height: 25px;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
}

.graph-explorer-connections-menu_objects-panel_bottom-panel__count-label {
  height: 25px;
  float: left;
  padding: 0px 5px;
  font-size: larger;
  display: flex;
  align-items: center;
  max-width: 60%;
}

.graph-explorer-connections-menu_objects-panel_bottom-panel__extra-elements {
  color: gray;
  cursor: help;
}

.graph-explorer-btn.graph-explorer-connections-menu_objects-panel_bottom-panel__add-button {
  height: 25px;
  padding-top: 1px;
  padding-bottom: 2px;
}

.graph-explorer-connections-menu_objects-panel_objects-list {
  border: 1px solid gray;
  height: 0;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 5px;
  margin-bottom: 5px;
}

.graph-explorer-connections-menu__link {
  color: #337ab7;
  cursor: pointer;
  text-decoration: none;
}
.graph-explorer-connections-menu__link:hover {
  text-decoration: underline;
}

.graph-explorer-dialog {
  background: #fff;
  border: 1px solid #333;
  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);
  position: absolute;
}
.graph-explorer-dialog__caption {
  font-weight: bold;
  position: absolute;
  top: -11px;
  left: 10px;
  background: white;
  padding-left: 3px;
  padding-right: 3px;
  border-radius: 6px;
}
.graph-explorer-dialog__close-button {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  border: 0 none;
  cursor: pointer;
  display: block;
  outline: none;
  padding: 0;
  position: absolute;
  top: -22px;
  right: -22px;
  height: 20px;
  width: 20px;
  opacity: 0.5;
  transition: 0.3s;
}
.graph-explorer-dialog__close-button:hover {
  opacity: 1;
}

.graph-explorer-dialog__bottom-right-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 10px 10px;
  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;
  cursor: nwse-resize;
}
.graph-explorer-dialog__bottom-right-handle::before {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 5px 5px;
  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;
}
.graph-explorer-dialog__bottom-right-handle:hover {
  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;
}

.graph-explorer-dialog__bottom-handle, .graph-explorer-dialog__right-handle {
  position: absolute;
  opacity: 0;
  background-color: black;
}
.graph-explorer-dialog__bottom-handle:hover, .graph-explorer-dialog__right-handle:hover {
  opacity: 0.1;
}

.graph-explorer-dialog__bottom-handle {
  bottom: 0;
  width: 100%;
  height: 5px;
  cursor: ns-resize;
}

.graph-explorer-dialog__right-handle {
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
  cursor: ew-resize;
}

.graph-explorer-edit-form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.graph-explorer-edit-form__body {
  overflow: auto;
  padding: 10px;
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.graph-explorer-edit-form__controls {
  border-top: 1px solid #ccc;
  padding: 10px;
  text-align: right;
  flex: 0 0 auto;
}
.graph-explorer-edit-form__apply-button {
  margin-right: 5px;
}
.graph-explorer-edit-form__form-row {
  display: block;
  margin-bottom: 10px;
}
.graph-explorer-edit-form__element-selector {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.graph-explorer-edit-form__search {
  flex-shrink: 0;
  position: relative;
}
.graph-explorer-edit-form__search-icon {
  opacity: 0.6;
  position: absolute;
  top: 50%;
  left: 10px;
  margin-top: -7px;
}
.graph-explorer-edit-form__search-input {
  padding-left: 33px;
}
.graph-explorer-edit-form__existing-elements-list {
  flex: 1 1 0;
  margin-top: 7px;
  padding-right: 10px;
  overflow-y: scroll;
}
.graph-explorer-edit-form__separator {
  margin: 7px 0;
  overflow: hidden;
  text-align: center;
}
.graph-explorer-edit-form__separator-text {
  color: #555;
  display: inline-block;
  font-size: 13px;
  position: relative;
}
.graph-explorer-edit-form__separator-text:before, .graph-explorer-edit-form__separator-text:after {
  content: "";
  border-top: 1px solid;
  position: absolute;
  top: 50%;
  margin: 0 10px;
  width: 500px;
}
.graph-explorer-edit-form__separator-text:before {
  left: 100%;
}
.graph-explorer-edit-form__separator-text:after {
  right: 100%;
}
.graph-explorer-edit-form__progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.graph-explorer-edit-form__control-row {
  position: relative;
  padding-bottom: 18px;
}
.graph-explorer-edit-form__control-error {
  color: red;
  position: absolute;
  bottom: 0;
  left: 0;
}

.graph-explorer-halo {
  position: absolute;
  pointer-events: none;
  border: 1.5px dashed #d8956d;
  border-radius: 2px;
  box-shadow: 0 0 5px 0 #d8956d inset;
}
.graph-explorer-halo__navigate {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  top: 50%;
  margin-top: -10px;
  right: -22px;
}
.graph-explorer-halo__navigate:hover {
  opacity: 1;
}
.graph-explorer-halo__navigate[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__navigate--open {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.graph-explorer-halo__navigate--closed {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.graph-explorer-halo__folow {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  top: 50%;
  margin-top: -10px;
  left: -22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.graph-explorer-halo__folow:hover {
  opacity: 1;
}
.graph-explorer-halo__folow[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__remove {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  top: -22px;
  right: -22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.graph-explorer-halo__remove:hover {
  opacity: 1;
}
.graph-explorer-halo__remove[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__expand {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  bottom: -22px;
  left: 50%;
  margin-left: -10px;
}
.graph-explorer-halo__expand:hover {
  opacity: 1;
}
.graph-explorer-halo__expand[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__expand--open {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.graph-explorer-halo__expand--closed {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.graph-explorer-halo__add-to-filter {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  bottom: -22px;
  right: -22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.graph-explorer-halo__add-to-filter:hover {
  opacity: 1;
}
.graph-explorer-halo__add-to-filter[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__revert {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  top: -22px;
  left: 50%;
  margin-left: -10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.graph-explorer-halo__revert:hover {
  opacity: 1;
}
.graph-explorer-halo__revert[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__establish-connection {
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0 none;
  cursor: pointer;
  outline: none;
  padding: 0;
  pointer-events: auto;
  width: 20px;
  height: 20px;
  opacity: 0.5;
  transition: opacity 0.3s;
  bottom: -22px;
  left: -22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.graph-explorer-halo__establish-connection:hover {
  opacity: 1;
}
.graph-explorer-halo__establish-connection[disabled] {
  cursor: not-allowed;
  opacity: 0.2;
}
.graph-explorer-halo__establish-connection-spinner {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: -22px;
  left: -22px;
}

.graph-explorer-halo-link__button {
  background: transparent;
  border: 0 none;
  cursor: pointer;
  padding: 0;
  position: absolute;
  opacity: 0.8;
  outline: none;
  transition: opacity 0.3s;
}
.graph-explorer-halo-link__button:hover {
  opacity: 1;
}
.graph-explorer-halo-link__button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.graph-explorer-halo-link__edit {
  background-color: #ccc;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 60%;
  border-radius: 10px;
  height: 20px;
  width: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.graph-explorer-halo-link__delete {
  background-color: #ccc;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 60%;
  border-radius: 10px;
  height: 20px;
  width: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.graph-explorer-halo-link__spinner {
  position: absolute;
}
.graph-explorer-halo-link__edit-label-button {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat;
  background-size: cover;
  border: 0 none;
  cursor: pointer;
  padding: 0;
  position: absolute;
  margin-left: 5px;
  outline: none;
  opacity: 0.5;
  transition: opacity 0.3s;
}
.graph-explorer-halo-link__edit-label-button:hover {
  opacity: 1;
}

.graph-explorer-instances-search {
  flex: auto;
  display: flex;
  flex-direction: column;
}
.graph-explorer-instances-search__criteria {
  flex-shrink: 0;
  margin: 10px 0 10px 0;
}
.graph-explorer-instances-search__criterions {
  padding-left: 15px;
  margin-bottom: 10px;
}
.graph-explorer-instances-search__criterions:empty {
  margin-bottom: 0;
}
.graph-explorer-instances-search__criterion {
  display: block;
  position: relative;
  width: 100%;
}
.graph-explorer-instances-search__criterion-class {
  border: black 1px dashed;
  background: rgb(255, 210, 33);
  padding: 0 0.5em 0 0.5em;
  word-wrap: break-word;
}
.graph-explorer-instances-search__criterion-element {
  border: black 1px dashed;
  background: rgb(255, 131, 92);
  padding: 0 0.5em 0 0.5em;
  word-wrap: break-word;
}
.graph-explorer-instances-search__criterion-link-type {
  border: black 1px dashed;
  background: rgb(202, 255, 206);
  padding: 0 0.5em 0 0.5em;
  word-wrap: break-word;
}
.graph-explorer-instances-search__link-direction {
  height: 1em;
  opacity: 0.5;
}
.graph-explorer-instances-search__criterion-remove {
  float: right;
  margin: 0 10px 4px 4px;
}
.graph-explorer-instances-search__text-criteria {
  margin: 0 10px;
}
.graph-explorer-instances-search__rest {
  padding: 10px 10px 0 10px;
  border-top: 1px solid rgb(221, 221, 221);
}
.graph-explorer-instances-search__results {
  padding-left: 0;
  padding-top: 10px;
  margin: 0 10px 0 10px;
  outline: none;
}
.graph-explorer-instances-search[data-state=finished] .graph-explorer-instances-search__results:empty:before {
  content: "No items correspond to the specified criteria.";
  font-style: italic;
}
.graph-explorer-instances-search__rest-end {
  margin: 5px 0 10px 0;
}
.graph-explorer-instances-search__load-more {
  width: 100%;
}

.link-types-toolbox {
  flex: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}
.link-types-toolbox__heading {
  padding: 10px;
}
.link-types-toolbox__searching-box {
  display: flex;
  align-items: center;
}
.link-types-toolbox__clearSearch {
  margin-left: -25px;
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
}
.link-types-toolbox__switch-all {
  margin-top: 5px;
}
.link-types-toolbox__rest {
  border-top: 1px solid #dddddd;
  flex: auto;
  display: flex;
  flex-direction: column;
}

.link-types-toolbox .panel-heading {
  flex-shrink: 0;
  -webkit-flex-shrink: 0; /* safari 8 */
}

.link-types-toolbox ul {
  margin-bottom: 0;
}

.link-types-toolbox .links-heading {
  margin-left: 0.4em;
}

.link-types-toolbox .links-heading span {
  border: black 1px dashed;
  background: rgb(255, 131, 92);
  padding: 0 0.5em 0 0.5em;
  word-wrap: break-word;
  line-height: 1.3;
}

.link-types-toolbox__heading .link-types-toolbox-controls {
  padding: 5px 15px;
  font-size: 14px;
  font-style: italic;
}

.link-types-toolbox__heading .link-types-toolbox-controls > span {
  padding-left: 0.3em;
}

.graph-explorer-list-group .linkInToolBox {
  padding: 0 0 0 5px;
  word-break: break-word;
}

.linkInToolBox > div {
  display: inline;
}
.linkInToolBox__new-tag {
  margin-left: 0.5em;
  white-space: normal;
  word-wrap: normal;
  border-radius: 2px;
  padding: 0 5px;
  background: orange;
}
.linkInToolBox .graph-explorer-badge {
  display: none;
  margin-left: 0.5em;
  white-space: normal;
  word-wrap: normal;
}
.linkInToolBox .link-title {
  font-size: 16px;
  color: black;
  display: inline;
}
.linkInToolBox .graph-explorer-btn-group {
  float: left;
  margin-top: 2px;
  margin-right: 6px;
  margin-bottom: 2px;
}
.linkInToolBox .graph-explorer-btn.graph-explorer-btn-default {
  border-color: rgb(195, 195, 195);
}
.linkInToolBox__filter-button {
  display: none;
  float: right;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  margin: 3px;
  cursor: pointer;
  opacity: 0.4;
  transition: opacity 200ms 0ms;
}
.linkInToolBox:hover .linkInToolBox__filter-button {
  opacity: 1;
  transition: opacity 200ms 0ms;
}

.connected-links .linkInToolBox .graph-explorer-badge {
  /* show connection count badge only in "Connected to Element" list */
  display: inline;
}

.connected-links .linkInToolBox__filter-button {
  /* show filter button only in "Connected to Element" list */
  display: inline;
}

.graph-explorer-list-element-view {
  position: relative;
  display: block;
  background: #808080;
  padding: 1px 1px 1px 10px;
  border-radius: 2px;
  margin: 0 0 2px 0;
  opacity: 1;
  cursor: move;
  user-select: none;
}
.graph-explorer-list-element-view--disabled {
  opacity: 0.4;
  cursor: default;
}
.graph-explorer-list-element-view__label {
  background: white;
  border-radius: 0 2px 2px 0;
  font-family: "Andale Mono", sans-serif;
  font-size: 15px;
  min-height: 1.3em;
  padding-left: 7px;
  padding-right: 5px;
  overflow-wrap: break-word;
}

.graph-explorer-text-highlight {
  font-weight: bold;
}

.graph-explorer-navigator {
  display: block;
  position: absolute;
  bottom: 25px;
  right: 25px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);
  transition: width 0.3s, height 0.3s;
}
.graph-explorer .graph-explorer-navigator {
  box-sizing: content-box;
}
.graph-explorer-navigator--collapsed {
  width: 26px;
  height: 26px;
}
.graph-explorer-navigator > canvas {
  transition: opacity 0.3s;
}
.graph-explorer-navigator--expanded > canvas {
  opacity: 1;
}
.graph-explorer-navigator--collapsed > canvas {
  opacity: 0;
}
.graph-explorer-navigator__toggle {
  position: absolute;
  background: transparent;
  border: none;
  outline: none;
  padding: 4px;
  opacity: 0.5;
  transition: opacity 0.3s;
}
.graph-explorer-navigator__toggle:hover {
  opacity: 1;
}
.graph-explorer-navigator--expanded .graph-explorer-navigator__toggle {
  top: 5px;
  left: 5px;
}
.graph-explorer-navigator--collapsed .graph-explorer-navigator__toggle {
  top: 0px;
  left: 0px;
}
.graph-explorer-navigator__toggle-icon {
  width: 18px;
  height: 18px;
  background-size: 18px 18px;
  background-repeat: no-repeat;
}
.graph-explorer-navigator--expanded .graph-explorer-navigator__toggle-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.graph-explorer-navigator--collapsed .graph-explorer-navigator__toggle-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

@keyframes graph-explorer-progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.graph-explorer-progress-bar {
  flex-shrink: 0;
  -webkit-flex-shrink: 0; /* safari 8 */
  width: 100%;
  background-color: #f5f5f5;
  background-image: linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%);
  background-repeat: repeat-x;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.graph-explorer-progress-bar__bar {
  float: left;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  transition: width 0.6s ease;
  background-color: #337ab7;
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-repeat: repeat-x;
  background-size: 40px 40px;
  animation: graph-explorer-progress-bar-stripes 2s linear infinite;
}
.graph-explorer-progress-bar--error .graph-explorer-progress-bar__bar {
  background-color: #E72F2F;
}
.graph-explorer-progress-bar--loading, .graph-explorer-progress-bar--error {
  /* property name | duration | delay */
  transition: height 300ms 300ms;
}
.graph-explorer-progress-bar--completed {
  /* property name | duration | delay */
  transition: height 200ms 0ms;
}

.graph-explorer-search-results {
  margin: 0;
  padding: 0;
  outline: none;
}

.graph-explorer-accordion {
  flex: auto;
  display: flex;
  height: 100%;
  width: 100%;
}
.graph-explorer-accordion--scrollable {
  overflow: auto;
}
.graph-explorer-accordion--vertical {
  flex-direction: column;
}
.graph-explorer-accordion--vertical:not(.graph-explorer-accordion--resizing) > .graph-explorer-accordion-item {
  transition: height 0.3s ease-in-out;
}

.graph-explorer-accordion-item {
  display: flex;
  position: relative;
  flex: auto;
}
.graph-explorer-accordion-item--resizing > .graph-explorer-accordion-item__handle, .graph-explorer-accordion-item__handle:hover {
  background: rgba(0, 0, 0, 0.1);
}
.graph-explorer-accordion-item--vertical {
  border-top: 1px solid lightgray;
}
.graph-explorer-accordion-item--vertical:first-child {
  border-top-width: 0;
}
.graph-explorer-accordion-item--horizontal {
  border-right: 1px solid lightgray;
}
.graph-explorer-accordion-item--horizontal:last-child {
  border-right-width: 0;
}
.graph-explorer-accordion-item__handle {
  position: absolute;
  z-index: 2;
}
.graph-explorer-accordion-item__handle-vertical {
  height: 5px;
  bottom: -2.5px;
  left: 0;
  width: 100%;
  cursor: ns-resize;
}
.graph-explorer-accordion-item__handle-horizontal {
  height: 100%;
  top: 0;
  right: -2.5px;
  width: 5px;
  cursor: ew-resize;
}
.graph-explorer-accordion-item__handle-btn {
  background: #fff;
  border: 2px solid #17b;
  box-shadow: 0 0 0 1px rgba(9, 30, 66, 0.08), 0 2px 4px 1px rgba(9, 30, 66, 0.08);
  border-radius: 10px;
  cursor: pointer;
  height: 20px;
  position: absolute;
  top: 50%;
  margin-top: -10px;
  width: 20px;
  z-index: 20;
  transition: 0.3s;
}
.graph-explorer-accordion-item__handle-btn::before {
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: cover;
  content: "";
  height: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -4px;
  margin-left: -4px;
  width: 8px;
  transition: background 0.3s;
}
.graph-explorer-accordion-item__handle-btn:hover {
  background: #17b;
}
.graph-explorer-accordion-item__handle-btn-left {
  left: 100%;
  margin-left: -10px;
}
.graph-explorer-accordion-item__handle-btn-left:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.graph-explorer-accordion-item__handle-btn-left:hover:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.graph-explorer-accordion-item__handle-btn-right {
  right: 100%;
  margin-right: -10px;
}
.graph-explorer-accordion-item__handle-btn-right:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.graph-explorer-accordion-item__handle-btn-right:hover:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.graph-explorer-accordion-item--collapsed .graph-explorer-accordion-item__handle-btn:before {
  transform: rotate(180deg);
}
.graph-explorer-accordion-item__inner {
  flex: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.graph-explorer-accordion-item__body {
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
}
.graph-explorer-accordion-item__header {
  padding-left: 20px;
  position: relative;
  flex-shrink: 0;
  font-size: 16px;
  background: #E4E4E4;
  cursor: default;
  /* unselectable */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.graph-explorer-accordion-item__header:before {
  border-top: 6px solid #555555;
  border-left: 3.5px solid transparent;
  border-right: 3.5px solid transparent;
  content: "";
  position: absolute;
  top: 50%;
  left: 7px;
  margin-top: -3px;
  -webkit-transition: 0.1s;
  -moz-transition: 0.1s;
  transition: 0.1s;
}
.graph-explorer-accordion-item--collapsed .graph-explorer-accordion-item__header:before {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.graph-explorer-accordion-item--collapsed .graph-explorer-accordion-item__body {
  display: none;
}

.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle,
.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle {
  height: 8px;
  width: 100%;
  top: initial;
  left: 0;
  cursor: ns-resize;
}
.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle-btn,
.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle-btn {
  height: 100%;
  width: 40px;
  top: 0;
  left: 50%;
  margin-left: -20px;
  margin-top: 0px;
}

.graph-explorer-drag-resizable-column {
  display: flex;
  flex-direction: column;
  position: relative;
}
.graph-explorer-drag-resizable-column__handle {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_23___}) repeat;
  width: 8px;
  height: 100%;
  position: absolute;
  top: 0;
  left: initial;
  z-index: 2;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
  cursor: ew-resize;
}
.graph-explorer-drag-resizable-column__handle-btn {
  background: #eee;
  cursor: pointer;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -20px;
  width: 100%;
  z-index: 1;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
}
.graph-explorer-drag-resizable-column__handle-btn::before {
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: cover;
  content: "";
  height: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -3px;
  margin-left: -3px;
  width: 6px;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
}
.graph-explorer-drag-resizable-column__handle-btn:hover {
  background: #b3b3b3;
  transform: scale(1.2);
}
.graph-explorer-drag-resizable-column--closed .graph-explorer-drag-resizable-column__handle-btn::before {
  transform: rotate(180deg);
}
.graph-explorer-drag-resizable-column--docked-left {
  margin-right: 8px;
}
.graph-explorer-drag-resizable-column--docked-left .graph-explorer-drag-resizable-column__handle {
  right: -8px;
}
.graph-explorer-drag-resizable-column--docked-left .graph-explorer-drag-resizable-column__handle-btn::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.graph-explorer-drag-resizable-column--docked-left .graph-explorer-drag-resizable-column__handle-btn:hover::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.graph-explorer-drag-resizable-column--docked-right {
  margin-left: 8px;
}
.graph-explorer-drag-resizable-column--docked-right .graph-explorer-drag-resizable-column__handle {
  left: -8px;
}
.graph-explorer-drag-resizable-column--docked-right .graph-explorer-drag-resizable-column__handle-btn::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.graph-explorer-drag-resizable-column--docked-right .graph-explorer-drag-resizable-column__handle-btn:hover::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.graph-explorer-drag-resizable-column--docked-top {
  margin-bottom: 8px;
}
.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle {
  bottom: -8px;
}
.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle-btn::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle-btn:hover::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.graph-explorer-drag-resizable-column--docked-bottom {
  margin-top: 8px;
}
.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle {
  top: -8px;
}
.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle-btn::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle-btn:hover::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

.introjs-tooltiptext {
  color: #333;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  line-height: 1.42857;
}

.graph-explorer-toolbar__language-selector {
  margin-left: 5px;
  margin-right: 5px;
}
.graph-explorer-toolbar__language-selector > label {
  margin-right: 5px;
}
.graph-explorer-toolbar__language-selector > label > span {
  vertical-align: middle;
}
.graph-explorer-toolbar__language-selector > select {
  height: 30px;
}
.graph-explorer-toolbar__toggle {
  line-height: 1;
}
.graph-explorer-toolbar__toggle:after {
  background-position: 0 0;
  background-repeat: no-repeat;
  content: "";
  display: block;
  height: 12px;
  margin: 3px 0;
  width: 12px;
}
.graph-explorer-toolbar__toggle-left:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.graph-explorer-toolbar__toggle-right:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.graph-explorer-toolbar__toggle.active {
  border-color: #c3c3c3;
}
.graph-explorer-toolbar__toggle-left.active:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.graph-explorer-toolbar__toggle-right.active:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.graph-explorer-toolbar__layout-group {
  float: left;
  margin-left: 5px;
  height: 30px;
}
.graph-explorer-toolbar__layout-group > label {
  margin-right: 5px;
}
.graph-explorer-toolbar__layout-group .btn-group, .graph-explorer-toolbar__layout-group button {
  height: 100%;
}

.graph-explorer-toolbar .graph-explorer-toolbar__undo,
.graph-explorer-toolbar .graph-explorer-toolbar__redo {
  display: none;
}

.graph-explorer {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  white-space: initial;
  color: #333;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  line-height: 1.42857;
}
.graph-explorer *, .graph-explorer *:before, .graph-explorer *:after {
  box-sizing: inherit;
}
.graph-explorer__toolbar-widget {
  position: absolute;
  left: 10px;
  top: 10px;
}
.graph-explorer__workspace {
  display: flex;
  flex: auto;
  overflow: hidden;
  flex-direction: column;
}
.graph-explorer__main-panel {
  display: flex;
  flex: auto;
  overflow: hidden;
  width: 0;
}
.graph-explorer--unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.graph-explorer--horizontal-resizing * {
  cursor: ew-resize !important;
}
.graph-explorer--vertical-resizing * {
  cursor: ns-resize !important;
}
.graph-explorer h4 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.1;
  margin-top: 10px;
  margin-bottom: 10px;
}
.graph-explorer select {
  color: inherit;
  margin: 0;
  font: inherit;
  line-height: inherit;
  text-transform: none;
}
.graph-explorer hr {
  border: 0;
  border-top: 1px solid #eee;
  height: 0;
}

.graph-explorer-scrollable {
  flex: 1 1 0px;
  overflow-y: scroll;
}

.graph-explorer-scrollable > * {
  position: relative;
}

.jstree-icon.jstree-themeicon.jstree-themeicon-custom {
  background-size: contain !important;
}

.graph-explorer-default-template, .graph-explorer-group-template__wrap {
  max-width: 450px;
  float: left;
  border-radius: 12px;
  border-style: solid;
  border-width: 1px;
}
.graph-explorer-default-template__thumbnail {
  text-align: center;
}
.graph-explorer-default-template__thumbnail > img {
  max-width: 200px;
}
.graph-explorer-default-template[data-expanded=true] .graph-explorer-default-template__thumbnail > img, [data-expanded=true].graph-explorer-group-template__wrap .graph-explorer-default-template__thumbnail > img {
  max-width: 350px;
}

.graph-explorer-default-template_type-line, .graph-explorer-group-template__type-line {
  padding: 0px 7px;
  color: white;
  height: 18px;
  margin-bottom: 2px;
  overflow: hidden;
  display: flex;
  align-items: baseline;
  margin-top: -3px;
}

div.graph-explorer-default-template_type-line__icon, div.graph-explorer-group-template__type-line-icon {
  position: inherit !important;
  margin-right: 4px;
}

.graph-explorer-default-template_type-line_text-container, .graph-explorer-group-template__type-line-text-container {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 0;
}

.graph-explorer-default-template_type-line_text-container__text, .graph-explorer-group-template__type-line-text {
  display: inline;
  white-space: nowrap;
  font-size: 12px;
}

.graph-explorer-default-template_body, .graph-explorer-group-template__body {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border-top-style: solid;
  border-top-width: 1px;
  background: white;
  padding: 7px 10px 8px 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.graph-explorer-default-template_body__label, .graph-explorer-group-template__label {
  font-size: 19px;
  font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  white-space: nowrap;
  word-wrap: break-word;
}

.graph-explorer-default-template_body_expander {
  width: 100%;
  overflow: hidden;
  display: flex;
}

.graph-explorer-default-template_body_expander__iri_label {
  font-size: 12px;
  font-weight: 100;
  margin-right: 15px;
  color: #b6b6b6;
}

.graph-explorer-default-template_body_expander_iri {
  font-size: 12px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.graph-explorer-default-template_body_expander_iri__link {
  color: #b6b6b6;
}

.graph-explorer-default-template_body_expander__hr {
  margin: 5px 0px 5px 0px;
}

.graph-explorer-default-template_body_expander_property-table {
  font-size: 15px;
  font-weight: 100;
  margin-bottom: 5px;
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.graph-explorer-default-template_body_expander_property-table_row {
  white-space: nowrap;
}

.graph-explorer-default-template_body_expander_property-table_row__key {
  display: inline-block;
  width: 50%;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: top;
}

.graph-explorer-default-template_body_expander_property-table_row_key {
  display: inline-block;
  width: 50%;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: top;
}

.graph-explorer-default-template_body_expander_property-table_row_key_values {
  display: inline-block;
  width: 50%;
  text-overflow: ellipsis;
  overflow: hidden;
}

.graph-explorer-default-template_body_expander_property-table_row_key_values__value {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  padding-right: 10px;
}

.graph-explorer-group-template {
  overflow: hidden;
}
.graph-explorer-group-template__wrap {
  max-width: none;
}
.graph-explorer-group-template__body {
  overflow: visible;
}
.graph-explorer-group-template__embedded-layer {
  margin-top: 7px;
}
.graph-explorer-group-template .graph-explorer-paper__canvas {
  border-color: #fff;
}

.graph-explorer-standard-template {
  min-width: 180px;
  max-width: 400px;
  float: left;
}
.graph-explorer-standard-template__main {
  border-radius: 2px;
  border: 1px solid;
}
.graph-explorer-standard-template__body {
  margin-left: 8px;
  border-radius: 0 2px 2px 0;
  border-left: 1px solid;
  padding: 3px 0;
  background: #fafaf9;
}
.graph-explorer-standard-template__body-horizontal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.graph-explorer-standard-template__body-content {
  flex-grow: 1;
  min-width: 0;
  margin-right: 12px;
}
.graph-explorer-standard-template__label {
  font-size: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.graph-explorer-standard-template__thumbnail {
  font-size: 26px;
  margin: 5px 10px;
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.graph-explorer-standard-template__thumbnail-image {
  max-height: 100%;
  max-width: 100%;
}
.graph-explorer-standard-template__thumbnail-icon {
  max-height: 26px;
  max-width: 26px;
}
.graph-explorer-standard-template__photo {
  border-bottom: 1px solid;
}
.graph-explorer-standard-template__photo-image {
  width: 100%;
  border-radius: 2px 2px 0 0;
}
.graph-explorer-standard-template__type {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  font-style: italic;
  color: #999;
  display: flex;
}
.graph-explorer-standard-template__type-value {
  width: 0;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.graph-explorer-standard-template__iri {
  width: 100%;
  overflow: hidden;
  display: flex;
}
.graph-explorer-standard-template__iri-key {
  font-size: 12px;
  margin-right: 4px;
  color: #b6b6b6;
}
.graph-explorer-standard-template__iri-value {
  font-size: 12px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.graph-explorer-standard-template__iri-value a {
  color: #b6b6b6;
}
.graph-explorer-standard-template__hr {
  margin: 5px 0;
}
.graph-explorer-standard-template__properties {
  font-size: 15px;
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.graph-explorer-standard-template__propertites-row {
  white-space: nowrap;
}
.graph-explorer-standard-template__properties-key {
  display: inline-block;
  width: 50%;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: top;
}
.graph-explorer-standard-template__properties-values {
  display: inline-block;
  width: 50%;
  text-overflow: ellipsis;
  overflow: hidden;
}
.graph-explorer-standard-template__properties-value {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  padding-right: 10px;
}
.graph-explorer-standard-template__pinned-props {
  border-top: 1px solid;
  margin: 0 5px;
}
.graph-explorer-standard-template__dropdown {
  border-radius: 2px;
  background-color: white;
  margin-top: 5px;
  border: 1px solid;
}
.graph-explorer-standard-template__dropdown-content {
  width: 100%;
  padding: 9px;
}
.graph-explorer-standard-template__actions {
  display: flex;
  justify-content: space-between;
}
.graph-explorer-standard-template__actions button {
  padding: 5px;
  min-width: 60px;
}`, "",{"version":3,"sources":["webpack://./styles/viewUtils/_spinner.scss","webpack://./styles/main.scss","webpack://./styles/viewUtils/_clearfix.scss","webpack://./styles/viewUtils/_label.scss","webpack://./styles/viewUtils/_btn.scss","webpack://./styles/viewUtils/_btn-group.scss","webpack://./styles/viewUtils/_form-control.scss","webpack://./styles/viewUtils/_input-group.scss","webpack://./styles/viewUtils/_list-group.scss","webpack://./styles/viewUtils/_badge.scss","webpack://./styles/diagram/_elementLayer.scss","webpack://./styles/diagram/_linkLayer.scss","webpack://./styles/diagram/_paperArea.scss","webpack://./styles/diagram/animation.scss","webpack://./styles/editor/_loadingWidget.scss","webpack://./styles/editor/_authoringState.scss","webpack://./styles/widgets/_authoringTools.scss","webpack://./styles/widgets/_classTree.scss","webpack://./styles/widgets/_connectionsMenu.scss","webpack://./styles/widgets/_dialog.scss","webpack://./styles/widgets/_editForm.scss","webpack://./styles/widgets/_halo.scss","webpack://./styles/widgets/_haloLink.scss","webpack://./styles/widgets/_instancesSearch.scss","webpack://./styles/widgets/_linksToolbox.scss","webpack://./styles/widgets/_listElementView.scss","webpack://./styles/widgets/_navigator.scss","webpack://./styles/widgets/_progressBar.scss","webpack://./styles/widgets/_searchResults.scss","webpack://./styles/workspace/_accordion.scss","webpack://./styles/workspace/_resizableSidebar.scss","webpack://./styles/workspace/_tutorial.scss","webpack://./styles/workspace/_toolbar.scss","webpack://./styles/workspace/_workspace.scss","webpack://./styles/templates/_icons.scss","webpack://./styles/templates/_defaultElement.scss","webpack://./styles/templates/_group.scss","webpack://./styles/templates/_standard.scss"],"names":[],"mappings":"AACE;EACE,+CAAA;EACA,wBAAA;EACA,+DAAA;EACA,mCAAA;ACAJ;ADGE;EACE,4BAAA;ACDJ;;ADKA;EACI;IAAK,uBAAA;ECDP;EDEE;IAAO,yBAAA;ECCT;AACF;ACfE;EACE,cAAA;EACA,WAAA;ADiBJ;ACdE;EACE,WAAA;ADgBJ;;AExBA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AF2BF;;AG9BA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;EACA,oBAAA;EACA,iCAAA;AHiCF;AG/BE;EACE,mBAAA;EACA,aAAA;AHiCJ;;AG5BA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;AH+BF;AG7BE;EACE,yBAAA;AH+BJ;AG5BE;EACE,yBAAA;EACA,qBAAA;AH8BJ;AG3BE;EACE,yBAAA;EACA,qBAAA;AH6BJ;AG1BE;EACE,yBAAA;AH4BJ;;AGxBA;EACE,yBAAA;EACA,mCAAA;EACA,qBAAA;AH2BF;AGzBE;EACE,yBAAA;AH2BJ;AGxBE;EACE,qBAAA;AH0BJ;AGvBE;EACE,qBAAA;AHyBJ;AGtBE;EACE,yBAAA;AHwBJ;;AGpBA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AHuBF;AGrBE;EACE,6DAAA;AHuBJ;;AGnBA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AHsBF;AGpBE;EACE,6DAAA;AHsBJ;;AIhHA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AJmHF;AIjHE;EACE,kBAAA;EACA,WAAA;AJmHJ;AIhHE;;;;EAIE,UAAA;AJkHJ;AI/GE;;;;EAIE,iBAAA;AJiHJ;AI9GE;EACE,cAAA;AJgHJ;AI7GE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AJ+GJ;AI5GE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AJ8GJ;;AKnJA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,0CAAA;ALsJF;AKpJE;EACE,qBAAA;EACA,UAAA;ALsJJ;AKnJE;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ALqJJ;;AM1KA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;AN6KF;AM3KE;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AN6KJ;AM1KE;EACE,0BAAA;EACA,6BAAA;AN4KJ;;AMxKA;EACE,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AN2KF;AMzKE;EACE,yBAAA;EACA,4BAAA;EACA,UAAA;EACA,iBAAA;AN2KJ;;AO3MA;EACE,SAAA;EACA,UAAA;AP8MF;;AO3MA;EACE,gBAAA;AP8MF;;AO3MA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AP8MF;;AQ7NA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;ARgOF;;AS5OA;EACE,YAAA;EACA,aAAA;AT+OF;;AS5OA;;EAGE,sBAAA;EACA,YAAA;EACA,2DAAA;EACA,eAAA;EACA,uBAAA;AT8OF;AS3OE;;EAAM,sBAAA;AT+OR;;AS3OE;EACE,mBAAA;AT8OJ;;AS1OA;EACE,uBAAA;EACA,YAAA;AT6OF;;AUtQE;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;AVyQJ;AUvQE;EACE,iCAAA;AVyQJ;AUtQE;EACE,kBAAA;AVwQJ;AUtQE;EACE,iBAAA;AVwQJ;AUrQE;EACE,UAAA;EACA,eAAA;AVuQJ;AUtQI;EAAW,UAAA;AVyQf;AUxQI;EAAS,aAAA;AV2Qb;AUzQM;EAAW,WAAA;AV4QjB;AUzQE;EACE,YAAA;AV2QJ;AUxQE;EACE,YAAA;AV0QJ;;AW3SA;EACE,UAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AX8SF;AW5SE;EACE,UAAA;EACA,gBAAA;AX8SJ;AW3SE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AX6SJ;AW1SE;EACE,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;AX4SJ;AW1SI;EACE,YAAA;AX4SN;AWxSE;EACE,gBAAA;AX0SJ;;AWtSA;EACE,kBAAA;AXySF;;AWtSA;EACE,YAAA;EACA,wBAAA;AXySF;;AYvVI;EACI,sCAAA;AZ0VR;AYxVI;EACI,gBAAA;EACA,UAAA;AZ0VR;;AYtVA;EACI,oCAAA;AZyVJ;;AapWA;EACE,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,WAAA;AbuWF;;AcjXE;EACE,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AdoXJ;AcjXE;EACE,mDAAA;EACA,YAAA;EACA,WAAA;AdmXJ;AchXE;EACE,iBAAA;EACA,iBAAA;AdkXJ;Ac/WE;EACE,cAAA;EACA,eAAA;AdiXJ;AchXI;EACE,0BAAA;AdkXN;Ac9WE;EACE,kBAAA;AdgXJ;Ac9WE;EACE,kBAAA;AdgXJ;Ac9WE;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;AdgXJ;;AezZA;EACE,YAAA;Af4ZF;Ae1ZE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;Af4ZJ;AezZE;EACE,YAAA;EACA,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;Af2ZJ;;AgB5aA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AhB+aF;AgB7aE;EACE,cAAA;EACA,qBAAA;AhB+aJ;AgB5aE;EACE,iBAAA;EACA,kBAAA;AhB8aJ;AgB3aE;EACE,cAAA;EACA,eAAA;AhB6aJ;AgB1aE;EACE,wCAAA;AhB4aJ;AgBzaE;EACE,kBAAA;EACA,iCAAA;EACA,YAAA;AhB2aJ;;AgBvaA;EACE,aAAA;AhB0aF;AgBxaE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AhB0aJ;AgBzaI;EAAM,cAAA;AhB4aV;AgBzaE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AhB2aJ;AgB1aI;EACE,4CAAA;EACA,qBAAA;EACA,eAAA;AhB4aN;AgB1aI;EACE,yBAAA;EACA,qBAAA;AhB4aN;AgBxaE;EACE,YAAA;AhB0aJ;AgBvaE;EACE,cAAA;EACA,YAAA;AhByaJ;AgBtaE;EACE,gBAAA;EACA,YAAA;AhBwaJ;AgBraE;EACE,iBAAA;AhBuaJ;AgBpaE;EACE,gBAAA;AhBsaJ;AgBnaE;EACE,iBAAA;AhBqaJ;AgBlaE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AhBoaJ;AgBjaE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AhBmaJ;AgBlaI;EACE,4CAAA;EACA,eAAA;AhBoaN;AgBhaE;EACE,cAAA;EACA,YAAA;AhBkaJ;AgB/ZE;EACE,gBAAA;AhBiaJ;AgBhaI;EACE,YAAA;AhBkaN;;AiBlhBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AjBqhBF;AiBnhBE;EACE,aAAA;AjBqhBJ;AiBlhBE;EACE,cAAA;EACA,UAAA;AjBohBJ;AiBjhBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AjBmhBJ;AiBjhBI;EACE,UAAA;AjBmhBN;AiB/gBE;EACE,cAAA;AjBihBJ;;AiB7gBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AjBghBF;;AiB7gBA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AjBghBF;;AiB7gBA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AjBghBF;;AiB7gBA;EACE,cAAA;EACA,iBAAA;AjBghBF;;AiB7gBA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,SAAA;AjBghBF;;AiB7gBA;EACE,aAAA;EACA,mBAAA;AjBghBF;;AiB7gBA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AjBghBF;;AiB7gBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AjBghBF;;AiB9gBA;EACE,sBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AjBihBF;;AiB9gBA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AjBihBF;AiB/gBE;EACE,yBAAA;AjBihBJ;;AiB7gBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AjBghBF;AiB9gBE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AjBghBJ;AiB7gBE;EACE,cAAA;EACA,iBAAA;AjB+gBJ;AiB5gBE;EACE,YAAA;EACA,yDAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AjB8gBJ;AiB7gBI;EAAU,UAAA;AjBghBd;AiB7gBE;EACE,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AjB+gBJ;AiB9gBI;EAAU,UAAA;AjBihBd;AiB9gBE;EACE,yBAAA;AjBghBJ;;AiB5gBA;EACI,qCAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AjB+gBJ;;AiB5gBA;EACE,iEAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;AjB+gBF;;AiB5gBA;EACE,iEAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;AjB+gBF;;AiB5gBA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AjB+gBF;;AiB5gBA;EACE,gBAAA;EACA,mBAAA;AjB+gBF;;AiB5gBA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AjB+gBF;;AiB5gBA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;AjB+gBJ;AiB7gBI;EACE,iBAAA;AjB+gBN;AiB9gBM;EAAa,YAAA;AjBihBnB;;AiB7gBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AjBghBF;;AiB7gBA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AjBghBF;;AiB7gBA;EACE,WAAA;EACA,YAAA;AjBghBF;;AiB7gBA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AjBghBF;;AiB7gBA;EACE,sBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AjBghBF;;AiB7gBA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AjBghBF;AiB9gBE;EACE,0BAAA;AjBghBJ;;AkBlyBA;EACE,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AlBqyBF;AkBnyBE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlBqyBJ;AkBlyBE;EACE,+DAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAEA,YAAA;EACA,gBAAA;AlBmyBJ;AkBjyBI;EACE,UAAA;AlBmyBN;;AkB9xBA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,qEAAA;EACA,mBAAA;AlBiyBF;AkB/xBE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,qEAAA;AlBiyBJ;AkB9xBE;EACE,oEAAA;AlBgyBJ;;AkB5xBA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;AlB+xBF;AkB7xBE;EACE,YAAA;AlB+xBJ;;AkB3xBA;EACE,SAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AlB8xBF;;AkB3xBA;EACE,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AlB8xBF;;AmBx3BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AnB23BF;AmBz3BE;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AnB23BJ;AmBx3BE;EACE,0BAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AnB03BJ;AmBv3BE;EACE,iBAAA;AnBy3BJ;AmBt3BE;EACE,cAAA;EACA,mBAAA;AnBw3BJ;AmBr3BE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AnBu3BJ;AmBp3BE;EACE,cAAA;EACA,kBAAA;AnBs3BJ;AmBn3BE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;AnBq3BJ;AmBl3BE;EACE,kBAAA;AnBo3BJ;AmBj3BE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AnBm3BJ;AmBh3BE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AnBk3BJ;AmB/2BE;EACE,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AnBi3BJ;AmB/2BI;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AnBi3BN;AmB92BI;EACE,UAAA;AnBg3BN;AmB72BI;EACE,WAAA;AnB+2BN;AmB32BE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AnB62BJ;AmB12BE;EACE,kBAAA;EACA,oBAAA;AnB42BJ;AmBz2BE;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AnB22BJ;;AoBr9BA;EACE,kBAAA;EACA,oBAAA;EAEA,4BAAA;EACA,kBAAA;EACA,mCAAA;ApBu9BF;AoBr4BE;EA3EE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAkCA,QAAA;EACA,iBAAA;EACA,YAAA;ApBi7BJ;AoBp9BI;EACE,UAAA;ApBs9BN;AoBn9BI;EACE,mBAAA;EACA,YAAA;ApBq9BN;AoB35BI;EACE,yDAAA;ApB65BN;AoB15BI;EACE,yDAAA;ApB45BN;AoBx5BE;EAxFE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAwCA,QAAA;EACA,iBAAA;EACA,WAAA;EAoCA,yDAAA;ApBw6BJ;AoBr/BI;EACE,UAAA;ApBu/BN;AoBp/BI;EACE,mBAAA;EACA,YAAA;ApBs/BN;AoB56BE;EA/FE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EA6BA,UAAA;EACA,YAAA;EAsDA,yDAAA;ApB47BJ;AoB/gCI;EACE,UAAA;ApBihCN;AoB9gCI;EACE,mBAAA;EACA,YAAA;ApBghCN;AoBh8BE;EArGE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EA8CA,aAAA;EACA,SAAA;EACA,kBAAA;ApB0/BJ;AoBziCI;EACE,UAAA;ApB2iCN;AoBxiCI;EACE,mBAAA;EACA,YAAA;ApB0iCN;AoBt9BI;EACE,0DAAA;ApBw9BN;AoBr9BI;EACE,0DAAA;ApBu9BN;AoBn9BE;EAlHE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAyDA,aAAA;EACA,YAAA;EA6CA,yDAAA;ApBm+BJ;AoBzkCI;EACE,UAAA;ApB2kCN;AoBxkCI;EACE,mBAAA;EACA,YAAA;ApB0kCN;AoBv+BE;EAxHE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAkBA,UAAA;EACA,SAAA;EACA,kBAAA;EAyFA,0DAAA;ApBw/BJ;AoBpmCI;EACE,UAAA;ApBsmCN;AoBnmCI;EACE,mBAAA;EACA,YAAA;ApBqmCN;AoB5/BE;EA9HE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAoDA,aAAA;EACA,WAAA;EA8DA,0DAAA;ApB4gCJ;AoB9nCI;EACE,UAAA;ApBgoCN;AoB7nCI;EACE,mBAAA;EACA,YAAA;ApB+nCN;AoBhhCE;EA1GE,kBAAA;EACA,WAhCY;EAiCZ,YAhCa;EAsEb,aAAA;EACA,WAAA;ApBwlCJ;;AqBtqCE;EACE,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;ArByqCJ;AqBvqCI;EACE,UAAA;ArByqCN;AqBtqCI;EACE,mBAAA;EACA,YAAA;ArBwqCN;AqB1pCE;EATE,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EAKA,0DAAA;ArBkqCJ;AqB/pCE;EAdE,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EAUA,0DAAA;ArBuqCJ;AqBpqCE;EACE,kBAAA;ArBsqCJ;AqBnqCE;EACE,0EAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;ArBqqCJ;AqBnqCI;EACE,UAAA;ArBqqCN;;AsBhuCA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AtBmuCF;AsBjuCE;EACE,cAAA;EACA,qBAAA;AtBmuCJ;AsBhuCE;EACE,kBAAA;EACA,mBAAA;AtBkuCJ;AsBjuCI;EAAU,gBAAA;AtBouCd;AsBjuCE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AtBmuCJ;AsBhuCE;EACE,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;AtBkuCJ;AsB/tCE;EACE,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;AtBiuCJ;AsB9tCE;EACE,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,qBAAA;AtBguCJ;AsB7tCE;EACE,WAAA;EACA,YAAA;AtB+tCJ;AsB5tCE;EACE,YAAA;EACA,sBAAA;AtB8tCJ;AsB3tCE;EAAmB,cAAA;AtB8tCrB;AsB5tCE;EACE,yBAAA;EACA,wCAAA;AtB8tCJ;AsB3tCE;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;AtB6tCJ;AsB1tCE;EACE,yDAAA;EACA,kBAAA;AtB4tCJ;AsBztCE;EAAc,oBAAA;AtB4tChB;AsB3tCE;EACE,WAAA;AtB6tCJ;;AuBvyCA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AvB0yCF;AuBxyCE;EACE,aAAA;AvB0yCJ;AuBvyCE;EACE,aAAA;EACA,mBAAA;AvByyCJ;AuBtyCE;EACE,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AvBwyCJ;AuBryCE;EACE,eAAA;AvBuyCJ;AuBpyCE;EACE,6BAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AvBsyCJ;;AuBlyCA;EACE,cAAA;EACA,sBAAA,EAAA,aAAA;AvBqyCF;;AuBlyCA;EACE,gBAAA;AvBqyCF;;AuBnyCA;EACE,kBAAA;AvBsyCF;;AuBpyCA;EACE,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;AvBuyCF;;AuBpyCA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AvBuyCF;;AuBryCA;EACE,mBAAA;AvBwyCF;;AuBryCA;EACE,kBAAA;EACA,sBAAA;AvBwyCF;;AuBpyCE;EAAU,eAAA;AvBwyCZ;AuBtyCE;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AvBwyCJ;AuBryCE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AvBuyCJ;AuBpyCE;EACE,eAAA;EACA,YAAA;EACA,eAAA;AvBsyCJ;AuBnyCE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AvBqyCJ;AuBlyCE;EACE,gCAAA;AvBoyCJ;AuBjyCE;EACE,aAAA;EACA,YAAA;EACA,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AvBmyCJ;AuBjyCE;EACE,UAAA;EACA,6BAAA;AvBmyCJ;;AuB/xCA;EACE,oEAAA;EACA,eAAA;AvBkyCF;;AuBhyCA;EACE,2DAAA;EACA,eAAA;AvBmyCF;;AwBp6CA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AxBu6CF;AwBr6CE;EACE,YAAA;EACA,eAAA;AxBu6CJ;AwBp6CE;EACE,iBAAA;EACA,0BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AxBs6CJ;;AwBl6CA;EACE,iBAAA;AxBq6CF;;AyBl8CA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EAQA,gBAAA;EACA,sBAAA;EACA,iDAAA;EAGA,mCAAA;AzB47CF;AyBr8CE;EACE,uBAAA;AzBu8CJ;AyB77CE;EACE,WAAA;EACA,YAAA;AzB+7CJ;AyB57CE;EACE,wBAAA;AzB87CJ;AyB57CE;EAAuB,UAAA;AzB+7CzB;AyB97CE;EAAwB,UAAA;AzBi8C1B;AyB/7CE;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EAEA,YAAA;EACA,wBAAA;AzBg8CJ;AyB97CI;EAEE,UAAA;AzB+7CN;AyB57CE;EACE,QAAA;EACA,SAAA;AzB87CJ;AyB57CE;EACE,QAAA;EACA,SAAA;AzB87CJ;AyB37CE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;AzB67CJ;AyB37CE;EACE,0DAAA;AzB67CJ;AyB37CE;EACE,0DAAA;AzB67CJ;;A0B9/CA;EACE;IACE,2BAAA;E1BigDF;E0B//CA;IACE,wBAAA;E1BigDF;AACF;A0B9/CA;EACE,cAAA;EACA,sBAAA,EAAA,aAAA;EACA,WAAA;EAEA,yBAAA;EACA,sEAAA;EACA,2BAAA;EACA,gBAAA;EACA,8CAAA;A1B+/CF;A0B7/CE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EAEA,yBAAA;EACA,qMAAA;EACA,2BAAA;EACA,0BAAA;EAEA,iEAAA;A1B6/CJ;A0B1/CE;EACE,yBAAA;A1B4/CJ;A0Bz/CE;EAEE,qCAAA;EACA,8BAAA;A1B0/CJ;A0Bv/CE;EACE,qCAAA;EACA,4BAAA;A1By/CJ;;A2B1iDA;EACE,SAAA;EACA,UAAA;EACA,aAAA;A3B6iDF;;A4BhjDA;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;A5BmjDF;A4BjjDE;EACE,cAAA;A5BmjDJ;A4BhjDE;EACE,sBAAA;A5BkjDJ;A4B/iDE;EACE,mCAAA;A5BijDJ;;A4B7iDA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;A5BgjDF;A4B9iDE;EACE,8BAAA;A5BgjDJ;A4B7iDE;EACE,+BAAA;A5B+iDJ;A4B7iDI;EACE,mBAAA;A5B+iDN;A4B3iDE;EACE,iCAAA;A5B6iDJ;A4B3iDI;EACE,qBAAA;A5B6iDN;A4BziDE;EACE,kBAAA;EACA,UAAA;A5B2iDJ;A4BxiDE;EACE,WAAA;EACA,cAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;A5B0iDJ;A4BviDE;EACE,YAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;A5ByiDJ;A4BtiDE;EACE,gBAAA;EACA,sBAAA;EACA,gFAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;A5BwiDJ;A4BtiDI;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,2BAAA;A5BwiDN;A4BriDI;EACE,gBAAA;A5BuiDN;A4BniDE;EACE,UAAA;EACA,kBAAA;A5BqiDJ;A4BpiDI;EAAW,0DAAA;A5BuiDf;A4BtiDI;EAAiB,0DAAA;A5ByiDrB;A4BtiDE;EACE,WAAA;EACA,mBAAA;A5BwiDJ;A4BviDI;EAAW,0DAAA;A5B0iDf;A4BziDI;EAAiB,0DAAA;A5B4iDrB;A4BziDE;EACE,yBAAA;A5B2iDJ;A4BxiDE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;A5B0iDJ;A4BviDE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;A5ByiDJ;A4BtiDE;EACE,kBAAA;EACA,kBAAA;EAEA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;A5BuiDJ;A4BriDI;EACE,6BAAA;EACA,oCAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EAEA,wBAAA;EACA,qBAAA;EACA,gBAAA;A5BsiDN;A4BliDE;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;A5BoiDJ;A4BjiDE;EACE,aAAA;A5BmiDJ;;A6B1sDE;;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;A7B8sDJ;A6B3sDE;;EACE,YAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;A7B8sDJ;;A6B1sDA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;A7B6sDF;A6B3sDE;EACE,gEAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;A7B6sDJ;A6B1sDE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;A7B4sDJ;A6B1sDI;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;A7B4sDN;A6BzsDI;EACE,mBAAA;EACA,qBAAA;A7B2sDN;A6BtsDI;EAAY,yBAAA;A7BysDhB;A6BtsDE;EAAiB,iBAAA;A7BysDnB;A6BxsDE;EAA2B,WAAA;A7B2sD7B;A6BzsDI;EAAY,0DAAA;A7B4sDhB;A6B3sDI;EAAkB,0DAAA;A7B8sDtB;A6B3sDE;EAAkB,gBAAA;A7B8sDpB;A6B7sDE;EAA4B,UAAA;A7BgtD9B;A6B9sDI;EAAY,0DAAA;A7BitDhB;A6BhtDI;EAAkB,0DAAA;A7BmtDtB;A6BhtDE;EAAgB,kBAAA;A7BmtDlB;A6BltDE;EAA0B,YAAA;A7BqtD5B;A6BntDI;EAAY,0DAAA;A7BstDhB;A6BrtDI;EAAkB,0DAAA;A7BwtDtB;A6BrtDE;EAAmB,eAAA;A7BwtDrB;A6BvtDE;EAA6B,SAAA;A7B0tD/B;A6BxtDI;EAAY,0DAAA;A7B2tDhB;A6B1tDI;EAAkB,0DAAA;A7B6tDtB;;A8Bt0DA;EACE,WAAA;EACA,+DAAA;EACA,eAAA;EACA,oBAAA;A9By0DF;;A+B10DE;EACE,gBAAA;EACA,iBAAA;A/B60DJ;A+B30DI;EACE,iBAAA;A/B60DN;A+B50DM;EAAS,sBAAA;A/B+0Df;A+B50DI;EACE,YAbU;A/B21DhB;A+B10DE;EACE,cAAA;A/B40DJ;A+Bz0DE;EACE,wBAAA;EACA,4BAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;A/B20DJ;A+Bx0DE;EACE,0DAAA;A/B00DJ;A+Bv0DE;EACE,0DAAA;A/By0DJ;A+Bt0DE;EACE,qBAAA;A/Bw0DJ;A+Br0DE;EACE,0DAAA;A/Bu0DJ;A+Bp0DE;EACE,0DAAA;A/Bs0DJ;A+Bn0DE;EACE,WAAA;EACA,gBAAA;EACA,YAtDY;A/B23DhB;A+Bn0DI;EACE,iBAAA;A/Bq0DN;A+Bl0DI;EACE,YAAA;A/Bo0DN;;A+B/zDA;;EAEE,aAAA;A/Bk0DF;;AgCt4DA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,+DAAA;EACA,eAAA;EACA,oBAAA;AhCw4DF;AgCt4DE;EACE,mBAAA;AhCw4DJ;AgCr4DE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AhCu4DJ;AgCp4DE;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;AhCs4DJ;AgCn4DE;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;AhCq4DJ;AgCl4DE;EACE,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AhCo4DJ;AgCj4DE;EAA2B,4BAAA;AhCo4D7B;AgCn4DE;EAAyB,4BAAA;AhCs4D3B;AgCp4DE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AhCs4DJ;AgCn4DE;EACE,cAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;AhCq4DJ;AgCl4DE;EACE,SAAA;EACA,0BAAA;EACA,SAAA;AhCo4DJ;;AgCh4DA;EACE,aAAA;EACA,kBAAA;AhCm4DF;;AgC/3DA;EACE,kBAAA;AhCk4DF;;AiC/8DA;EACE,mCAAA;AjCk9DF;;AkCn9DA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AlCs9DF;AkCp9DE;EACE,kBAAA;AlCs9DJ;AkCr9DI;EACE,gBAAA;AlCu9DN;AkCn9DE;EACE,gBAAA;AlCq9DJ;;AkCj9DA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AlCo9DF;;AkCj9DA;EACE,4BAAA;EACA,iBAAA;AlCo9DF;;AkCj9DA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,QAAA;AlCo9DF;;AkCl9DA;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AlCq9DF;;AkCl9DA;EACE,+BAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AlCq9DF;;AkCl9DA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AlCq9DF;;AkCl9DA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AlCq9DF;;AkCl9DA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AlCq9DF;;AkCl9DA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AlCq9DF;;AkCl9DA;EACE,cAAA;AlCq9DF;;AkCl9DA;EACE,uBAAA;AlCq9DF;;AkCl9DA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlCq9DF;;AkCl9DA;EACE,mBAAA;AlCq9DF;;AkCl9DA;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AlCq9DF;;AkCl9DA;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AlCq9DF;;AkCl9DA;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AlCq9DF;;AkCl9DA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AlCq9DF;;AmC9lEA;EACE,gBAAA;AnCimEF;AmC/lEE;EAEE,eAAA;AnCgmEJ;AmC7kEE;EAEE,iBAAA;AnC8kEJ;AmCvkEE;EACE,eAAA;AnCykEJ;AmCtkEE;EACE,kBAAA;AnCwkEJ;;AoChnEA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;ApCmnEF;AoCjnEE;EACE,kBAAA;EACA,iBAAA;ApCmnEJ;AoChnEE;EACE,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;ApCknEJ;AoC/mEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;ApCinEJ;AoC9mEE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;ApCgnEJ;AoC7mEE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ApC+mEJ;AoC5mEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ApC8mEJ;AoC3mEE;EACE,gBAAA;EACA,eAAA;ApC6mEJ;AoC1mEE;EACE,gBAAA;EACA,eAAA;ApC4mEJ;AoCzmEE;EACE,wBAAA;ApC2mEJ;AoCxmEE;EACE,WAAA;EACA,0BAAA;ApC0mEJ;AoCvmEE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ApCymEJ;AoCtmEE;EACE,QAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;ApCwmEJ;AoCrmEE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;ApCumEJ;AoCpmEE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ApCsmEJ;AoCnmEE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ApCqmEJ;AoClmEE;EACE,cAAA;ApComEJ;AoCjmEE;EACE,aAAA;ApCmmEJ;AoChmEE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ApCkmEJ;AoC/lEE;EACE,mBAAA;ApCimEJ;AoC9lEE;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;ApCgmEJ;AoC7lEE;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;ApC+lEJ;AoC5lEE;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;ApC8lEJ;AoC3lEE;EACE,qBAAA;EACA,aAAA;ApC6lEJ;AoC1lEE;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;ApC4lEJ;AoCzlEE;EACE,WAAA;EACA,YAAA;ApC2lEJ;AoCxlEE;EACE,aAAA;EACA,8BAAA;ApC0lEJ;AoCzlEI;EACE,YAAA;EACA,eAAA;ApC2lEN","sourcesContent":[".graph-explorer-spinner {\n  &__arrow {\n    animation-name: graph-explorer-spinner-rotation;\n    animation-duration: 1.5s;\n    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n    animation-iteration-count: infinite;\n  }\n\n  &[data-error='true'] &__arrow {\n    animation-iteration-count: 1;\n  }\n}\n\n@keyframes graph-explorer-spinner-rotation {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n",".graph-explorer-spinner__arrow {\n  animation-name: graph-explorer-spinner-rotation;\n  animation-duration: 1.5s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-iteration-count: infinite;\n}\n.graph-explorer-spinner[data-error=true] .graph-explorer-spinner__arrow {\n  animation-iteration-count: 1;\n}\n\n@keyframes graph-explorer-spinner-rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.clearfix:before, .clearfix:after {\n  display: table;\n  content: \"\";\n}\n.clearfix:after {\n  clear: both;\n}\n\n.graph-explorer-label {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.graph-explorer-btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  text-transform: none;\n  transition: background-color 0.3s;\n}\n.graph-explorer-btn[disabled] {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.graph-explorer-btn-default {\n  background-color: #fff;\n  border-color: #ccc;\n  color: #333;\n}\n.graph-explorer-btn-default:hover {\n  background-color: #e0e0e0;\n}\n.graph-explorer-btn-default.active {\n  background-color: #e0e0e0;\n  border-color: #dbdbdb;\n}\n.graph-explorer-btn-default.active:hover {\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.graph-explorer-btn-default[disabled], .graph-explorer-btn-default[disabled]:hover, .graph-explorer-btn-default[disabled].active, .graph-explorer-btn-default[disabled].active:hover {\n  background-color: #e0e0e0;\n}\n\n.graph-explorer-btn-primary {\n  color: rgb(255, 255, 255);\n  background-color: rgb(51, 122, 183);\n  border-color: #245580;\n}\n.graph-explorer-btn-primary:hover, .graph-explorer-btn-primary:focus, .graph-explorer-btn-primary:active {\n  background-color: #265a88;\n}\n.graph-explorer-btn-primary:hover, .graph-explorer-btn-primary:focus {\n  border-color: #204d74;\n}\n.graph-explorer-btn-primary.active {\n  border-color: #245580;\n}\n.graph-explorer-btn-primary[disabled], .graph-explorer-btn-primary[disabled]:hover, .graph-explorer-btn-primary[disabled]:focus, .graph-explorer-btn-primary[disabled]:active, .graph-explorer-btn-primary[disabled].active {\n  background-color: #265a88;\n}\n\n.graph-explorer-btn-success {\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n  color: #fff;\n  transition: 0.3s;\n}\n.graph-explorer-btn-success:hover {\n  background: rgb(71.3641025641, 163.8358974359, 71.3641025641);\n}\n\n.graph-explorer-btn-danger {\n  background-color: #c9302c;\n  border-color: #c9302c;\n  color: #fff;\n  transition: 0.3s;\n}\n.graph-explorer-btn-danger:hover {\n  background: rgb(167.5273469388, 40.0065306122, 36.6726530612);\n}\n\n.graph-explorer-btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.graph-explorer-btn-group > .graph-explorer-btn, .graph-explorer-btn-group > .graph-explorer-btn-group {\n  position: relative;\n  float: left;\n}\n.graph-explorer-btn-group > .graph-explorer-btn:hover,\n.graph-explorer-btn-group > .graph-explorer-btn:focus,\n.graph-explorer-btn-group > .graph-explorer-btn.active,\n.graph-explorer-btn-group > .graph-explorer-btn.active:hover {\n  z-index: 2;\n}\n.graph-explorer-btn-group .graph-explorer-btn + .graph-explorer-btn,\n.graph-explorer-btn-group .graph-explorer-btn + .graph-explorer-btn-group,\n.graph-explorer-btn-group .graph-explorer-btn-group + .graph-explorer-btn,\n.graph-explorer-btn-group .graph-explorer-btn-group + .graph-explorer-btn-group {\n  margin-left: -1px;\n}\n.graph-explorer-btn-group > .graph-explorer-btn:first-child {\n  margin-left: 0;\n}\n.graph-explorer-btn-group-sm > .graph-explorer-btn {\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 5px 10px;\n}\n.graph-explorer-btn-group-xs > .graph-explorer-btn {\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 1px 5px;\n}\n\n.graph-explorer-form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  margin: 0;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background: #fff;\n  border: 1px solid #ccc;\n  transition: border-color ease-in-out 0.15s;\n}\n.graph-explorer-form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n}\n.graph-explorer-form-control:disabled {\n  background-color: #eee;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.graph-explorer-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.graph-explorer-input-group .graph-explorer-form-control {\n  display: table-cell;\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.graph-explorer-input-group .graph-explorer-form-control:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.graph-explorer-input-group-btn {\n  display: table-cell;\n  width: 1%;\n  vertical-align: middle;\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.graph-explorer-input-group-btn:last-child > .graph-explorer-btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  z-index: 2;\n  margin-left: -1px;\n}\n\n.graph-explorer-list-group {\n  margin: 0;\n  padding: 0;\n}\n\n.graph-explorer-list-group-item:last-child {\n  margin-bottom: 0;\n}\n\n.graph-explorer-list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n.graph-explorer-badge {\n  display: inline-block;\n  min-width: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: rgb(119, 119, 119);\n  padding: 3px 7px;\n  border-radius: 10px;\n}\n\n.graph-explorer-overlayed-element {\n  cursor: move;\n  outline: none;\n}\n\n.graph-explorer-overlayed-element,\n.graph-explorer-exported-element {\n  box-sizing: border-box;\n  color: black;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n}\n.graph-explorer-overlayed-element img,\n.graph-explorer-exported-element img {\n  vertical-align: middle;\n}\n\n.graph-explorer-exported-element *, .graph-explorer-exported-element *:before, .graph-explorer-exported-element *:after {\n  box-sizing: inherit;\n}\n\n.graph-explorer-overlayed-element--blurred {\n  filter: grayscale(100%);\n  opacity: 0.5;\n}\n\n.graph-explorer-link__wrap {\n  stroke-width: 12px;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  stroke: transparent;\n  fill: none;\n}\n.graph-explorer-link:hover .graph-explorer-link__wrap {\n  stroke: rgba(140, 140, 140, 0.44);\n}\n.graph-explorer-link__vertex {\n  cursor: all-scroll;\n}\n.graph-explorer-link:not(:hover) .graph-explorer-link__vertex {\n  fill: transparent;\n}\n.graph-explorer-link__vertex-tools {\n  opacity: 0;\n  cursor: pointer;\n}\n.graph-explorer-link__vertex-tools > circle {\n  fill: gray;\n}\n.graph-explorer-link__vertex-tools > path {\n  stroke: white;\n}\n.graph-explorer-link__vertex-tools:hover > circle {\n  fill: black;\n}\n.graph-explorer-link:hover .graph-explorer-link__vertex-tools {\n  opacity: 0.8;\n}\n.graph-explorer-link--blurred {\n  opacity: 0.5;\n}\n\n.graph-explorer-paper-area {\n  flex: auto;\n  width: 0;\n  display: flex;\n  position: relative;\n  cursor: default;\n  background: #fff;\n}\n.graph-explorer-paper-area__area {\n  flex: auto;\n  overflow: hidden;\n}\n.graph-explorer-paper-area__widgets {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.graph-explorer-paper-area__watermark {\n  background-size: cover;\n  width: 8%;\n  max-width: 130px;\n  min-width: 50px;\n  position: absolute;\n  top: 15px;\n  right: 25px;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n.graph-explorer-paper-area__watermark:hover {\n  opacity: 0.5;\n}\n.graph-explorer-paper-area--hide-scrollbars {\n  overflow: hidden;\n}\n\n.graph-explorer-paper {\n  position: relative;\n}\n\n.graph-explorer-exported-watermark {\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n\n.graph-explorer-paper-area--animated .graph-explorer-overlayed-element {\n  transition: transform 0.5s ease-in-out;\n}\n.graph-explorer-paper-area--animated .graph-explorer-link-layer, .graph-explorer-paper-area--animated .graph-explorer-paper-area__widgets {\n  transition: none;\n  opacity: 0;\n}\n\n.graph-explorer-link-layer, .graph-explorer-paper-area__widgets {\n  transition: opacity 0.5s ease-in-out;\n}\n\n.graph-explorer-loading-widget {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 10;\n}\n\n.graph-explorer-authoring-state__item-error {\n  align-self: flex-end;\n  margin: 0px 5px;\n  display: flex;\n  align-items: center;\n  cursor: help;\n}\n.graph-explorer-authoring-state__item-error-icon {\n  background: url(\"../images/font-awesome/exclamation-triangle.svg\");\n  height: 15px;\n  width: 17px;\n}\n.graph-explorer-authoring-state__state-label {\n  font-weight: bold;\n  margin-right: 5px;\n}\n.graph-explorer-authoring-state__state-cancel {\n  color: #3f87a6;\n  cursor: pointer;\n}\n.graph-explorer-authoring-state__state-cancel:hover {\n  text-decoration: underline;\n}\n.graph-explorer-authoring-state__state-indicator {\n  position: absolute;\n}\n.graph-explorer-authoring-state__state-indicator-container {\n  position: relative;\n}\n.graph-explorer-authoring-state__state-indicator-body {\n  position: absolute;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 5px;\n}\n\n.graph-explorer-authoring-tools {\n  margin: 10px;\n}\n.graph-explorer-authoring-tools__create-entity {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  white-space: normal;\n}\n.graph-explorer-authoring-tools__type-label {\n  color: black;\n  border: black 1px dashed;\n  background: rgb(255, 210, 33);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n\n.graph-explorer-class-tree {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n.graph-explorer-class-tree__filter {\n  flex-shrink: 0;\n  margin: 10px 0 10px 0;\n}\n.graph-explorer-class-tree__filter-group {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.graph-explorer-class-tree__only-creatable {\n  display: block;\n  margin-top: 5px;\n}\n.graph-explorer-class-tree__tree {\n  border-top: 1px solid rgb(221, 221, 221);\n}\n.graph-explorer-class-tree__spinner {\n  align-self: center;\n  /* center vertically in flexbox */\n  margin: auto;\n}\n\n.graph-explorer-class-leaf {\n  margin: 1px 0;\n}\n.graph-explorer-class-leaf__row {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  user-select: none;\n}\n.graph-explorer-class-leaf__row > * {\n  flex-shrink: 0;\n}\n.graph-explorer-class-leaf__body {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  font-size: 15px;\n  padding: 1px;\n  border: 1px solid;\n  border-color: transparent;\n}\n.graph-explorer-class-leaf__body:hover {\n  background: rgba(220, 235, 255, 0.568627451);\n  border-color: #ccefff;\n  cursor: pointer;\n}\n.graph-explorer-class-leaf__body--selected {\n  background-color: #beebff;\n  border-color: #8edcff;\n}\n.graph-explorer-class-leaf__icon-container {\n  height: 20px;\n}\n.graph-explorer-class-leaf__icon {\n  display: block;\n  height: 100%;\n}\n.graph-explorer-class-leaf__label {\n  margin-left: 5px;\n  color: black;\n}\n.graph-explorer-class-leaf__highlighted-term {\n  font-weight: bold;\n}\n.graph-explorer-class-leaf__count {\n  margin-left: 5px;\n}\n.graph-explorer-class-leaf__children {\n  margin-left: 20px;\n}\n.graph-explorer-class-leaf__no-toggle {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n}\n.graph-explorer-class-leaf__toggle {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin: 5px;\n}\n.graph-explorer-class-leaf__toggle:hover:not(:empty) {\n  background: rgba(220, 235, 255, 0.568627451);\n  cursor: pointer;\n}\n.graph-explorer-class-leaf__toggle-icon {\n  display: block;\n  height: 100%;\n}\n.graph-explorer-class-leaf__create {\n  margin-left: 5px;\n}\n.graph-explorer-class-leaf__create > button {\n  cursor: move;\n}\n\n.graph-explorer-connections-menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.graph-explorer-connections-menu__sort-switch {\n  display: none;\n}\n.graph-explorer-connections-menu__sort-switch:checked + .graph-explorer-connections-menu__sort-switch-label {\n  color: #337ab7;\n  opacity: 1;\n}\n.graph-explorer-connections-menu__sort-switch-label {\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  opacity: 0.4;\n  text-align: center;\n}\n.graph-explorer-connections-menu__sort-switch-label:hover {\n  opacity: 1;\n}\n.graph-explorer-connections-menu__search-line-input {\n  flex: 1 1 100%;\n}\n\n.graph-explorer-connections-menu_bread-crumbs {\n  padding: 10px;\n  padding-bottom: 0px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 27px;\n  min-height: 27px;\n  flex-grow: 0;\n}\n\n.graph-explorer-connections-menu__title-label {\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n\n.graph-explorer-connections-menu_search-line {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.graph-explorer-connections-menu_search-line-sort-switches {\n  flex: 0 0 20px;\n  margin-left: 10px;\n}\n\n.graph-explorer-connections-menu_links-list {\n  padding: 5px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-top: 1px solid #dbdbdb;\n  flex-grow: 1;\n  margin: 0;\n}\n\n.ocm_links-list-empty {\n  display: flex;\n  align-items: center;\n}\n\n.graph-explorer-connections-menu_links-list__empty {\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n  text-align: center;\n}\n\n.graph-explorer-connections-menu__loading,\n.graph-explorer-connections-menu__error {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n}\n\n.graph-explorer-connections-menu__loading-objects {\n  border: 1px solid gray;\n  flex-grow: 1;\n  box-shadow: inset 0px 0px 23px -8px gray;\n  background-color: whitesmoke;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n\n.graph-explorer-connections-menu__move-to-filter {\n  display: flex;\n  padding: 5px 10px;\n  user-select: none;\n  cursor: pointer;\n}\n.graph-explorer-connections-menu__move-to-filter:hover {\n  background-color: #e6e6e6;\n}\n\n.link-in-popup-menu {\n  display: flex;\n  overflow: hidden;\n  padding: 0 5px 0 0;\n  align-items: center;\n  margin-bottom: 4px;\n  background: #f7f7f7;\n}\n.link-in-popup-menu__link-title {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 5px 0px 5px 5px;\n}\n.link-in-popup-menu__count {\n  flex-shrink: 0;\n  margin-left: 10px;\n}\n.link-in-popup-menu__navigate-button {\n  float: right;\n  background-image: url(\"../images/expand-link.png\");\n  width: 16px;\n  height: 16px;\n  opacity: 0.5;\n  margin-left: 10px;\n  min-width: 16px;\n  background-size: cover;\n}\n.link-in-popup-menu__navigate-button:hover {\n  opacity: 1;\n}\n.link-in-popup-menu__filter-button {\n  background-image: url(\"../images/add-to-filter.png\");\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  opacity: 0.4;\n  margin-left: 10px;\n}\n.link-in-popup-menu__filter-button:hover {\n  opacity: 1;\n}\n.link-in-popup-menu:hover {\n  background-color: #e2e2e2;\n}\n\n.link-in-popup-menu_direction {\n  background: rgba(219, 219, 219, 0.35);\n  min-height: 30px;\n  padding: 5px 0px 5px 10px;\n  display: flex;\n  align-items: center;\n}\n\n.link-in-popup-menu_direction__in-direction {\n  background: url(\"../images/direction-in.png\") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 14px 0 0;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.link-in-popup-menu_direction__out-direction {\n  background: url(\"../images/direction-out.png\") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 8px 0 6px;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.graph-explorer-connections-menu_links-list__loading {\n  text-align: center;\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n}\n\n.graph-explorer-connections-menu_links-list__hr {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.graph-explorer-connections-menu_objects-panel {\n  flex-grow: 1;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n\n.graph-explorer-connections-menu_objects-panel__select-all {\n  white-space: nowrap;\n  margin-bottom: 5px;\n  display: flex;\n}\n.graph-explorer-connections-menu_objects-panel__select-all input {\n  margin-right: 5px;\n}\n.graph-explorer-connections-menu_objects-panel__select-all input:disabled {\n  opacity: 0.3;\n}\n\n.graph-explorer-connections-menu_objects-panel_bottom-panel {\n  height: 25px;\n  white-space: nowrap;\n  display: flex;\n  justify-content: space-between;\n}\n\n.graph-explorer-connections-menu_objects-panel_bottom-panel__count-label {\n  height: 25px;\n  float: left;\n  padding: 0px 5px;\n  font-size: larger;\n  display: flex;\n  align-items: center;\n  max-width: 60%;\n}\n\n.graph-explorer-connections-menu_objects-panel_bottom-panel__extra-elements {\n  color: gray;\n  cursor: help;\n}\n\n.graph-explorer-btn.graph-explorer-connections-menu_objects-panel_bottom-panel__add-button {\n  height: 25px;\n  padding-top: 1px;\n  padding-bottom: 2px;\n}\n\n.graph-explorer-connections-menu_objects-panel_objects-list {\n  border: 1px solid gray;\n  height: 0;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.graph-explorer-connections-menu__link {\n  color: #337ab7;\n  cursor: pointer;\n  text-decoration: none;\n}\n.graph-explorer-connections-menu__link:hover {\n  text-decoration: underline;\n}\n\n.graph-explorer-dialog {\n  background: #fff;\n  border: 1px solid #333;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  position: absolute;\n}\n.graph-explorer-dialog__caption {\n  font-weight: bold;\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n.graph-explorer-dialog__close-button {\n  background: transparent url(\"../images/font-awesome/times-circle-regular.svg\");\n  background-size: contain;\n  border: 0 none;\n  cursor: pointer;\n  display: block;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  top: -22px;\n  right: -22px;\n  height: 20px;\n  width: 20px;\n  opacity: 0.5;\n  transition: 0.3s;\n}\n.graph-explorer-dialog__close-button:hover {\n  opacity: 1;\n}\n\n.graph-explorer-dialog__bottom-right-handle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 10px 10px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n  cursor: nwse-resize;\n}\n.graph-explorer-dialog__bottom-right-handle::before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 5px 5px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n}\n.graph-explorer-dialog__bottom-right-handle:hover {\n  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\n}\n\n.graph-explorer-dialog__bottom-handle, .graph-explorer-dialog__right-handle {\n  position: absolute;\n  opacity: 0;\n  background-color: black;\n}\n.graph-explorer-dialog__bottom-handle:hover, .graph-explorer-dialog__right-handle:hover {\n  opacity: 0.1;\n}\n\n.graph-explorer-dialog__bottom-handle {\n  bottom: 0;\n  width: 100%;\n  height: 5px;\n  cursor: ns-resize;\n}\n\n.graph-explorer-dialog__right-handle {\n  top: 0;\n  right: 0;\n  width: 5px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.graph-explorer-edit-form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.graph-explorer-edit-form__body {\n  overflow: auto;\n  padding: 10px;\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.graph-explorer-edit-form__controls {\n  border-top: 1px solid #ccc;\n  padding: 10px;\n  text-align: right;\n  flex: 0 0 auto;\n}\n.graph-explorer-edit-form__apply-button {\n  margin-right: 5px;\n}\n.graph-explorer-edit-form__form-row {\n  display: block;\n  margin-bottom: 10px;\n}\n.graph-explorer-edit-form__element-selector {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.graph-explorer-edit-form__search {\n  flex-shrink: 0;\n  position: relative;\n}\n.graph-explorer-edit-form__search-icon {\n  opacity: 0.6;\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  margin-top: -7px;\n}\n.graph-explorer-edit-form__search-input {\n  padding-left: 33px;\n}\n.graph-explorer-edit-form__existing-elements-list {\n  flex: 1 1 0;\n  margin-top: 7px;\n  padding-right: 10px;\n  overflow-y: scroll;\n}\n.graph-explorer-edit-form__separator {\n  margin: 7px 0;\n  overflow: hidden;\n  text-align: center;\n}\n.graph-explorer-edit-form__separator-text {\n  color: #555;\n  display: inline-block;\n  font-size: 13px;\n  position: relative;\n}\n.graph-explorer-edit-form__separator-text:before, .graph-explorer-edit-form__separator-text:after {\n  content: \"\";\n  border-top: 1px solid;\n  position: absolute;\n  top: 50%;\n  margin: 0 10px;\n  width: 500px;\n}\n.graph-explorer-edit-form__separator-text:before {\n  left: 100%;\n}\n.graph-explorer-edit-form__separator-text:after {\n  right: 100%;\n}\n.graph-explorer-edit-form__progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.graph-explorer-edit-form__control-row {\n  position: relative;\n  padding-bottom: 18px;\n}\n.graph-explorer-edit-form__control-error {\n  color: red;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.graph-explorer-halo {\n  position: absolute;\n  pointer-events: none;\n  border: 1.5px dashed #d8956d;\n  border-radius: 2px;\n  box-shadow: 0 0 5px 0 #d8956d inset;\n}\n.graph-explorer-halo__navigate {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: 50%;\n  margin-top: -10px;\n  right: -22px;\n}\n.graph-explorer-halo__navigate:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__navigate[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__navigate--open {\n  background-image: url(\"../images/connections.svg\");\n}\n.graph-explorer-halo__navigate--closed {\n  background-image: url(\"../images/close-connections.svg\");\n}\n.graph-explorer-halo__folow {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: 50%;\n  margin-top: -10px;\n  left: -22px;\n  background-image: url(\"../images/link.svg\");\n}\n.graph-explorer-halo__folow:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__folow[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__remove {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: -22px;\n  right: -22px;\n  background-image: url(\"../images/delete.svg\");\n}\n.graph-explorer-halo__remove:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__remove[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__expand {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  left: 50%;\n  margin-left: -10px;\n}\n.graph-explorer-halo__expand:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__expand[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__expand--open {\n  background-image: url(\"../images/expand-properties.png\");\n}\n.graph-explorer-halo__expand--closed {\n  background-image: url(\"../images/collapse-properties.png\");\n}\n.graph-explorer-halo__add-to-filter {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  right: -22px;\n  background-image: url(\"../images/add-to-filter.png\");\n}\n.graph-explorer-halo__add-to-filter:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__add-to-filter[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__revert {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: -22px;\n  left: 50%;\n  margin-left: -10px;\n  background-image: url(\"../images/font-awesome/undo-solid.svg\");\n}\n.graph-explorer-halo__revert:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__revert[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__establish-connection {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  left: -22px;\n  background-image: url(\"../images/font-awesome/plug.svg\");\n}\n.graph-explorer-halo__establish-connection:hover {\n  opacity: 1;\n}\n.graph-explorer-halo__establish-connection[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.graph-explorer-halo__establish-connection-spinner {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  bottom: -22px;\n  left: -22px;\n}\n\n.graph-explorer-halo-link__button {\n  background: transparent;\n  border: 0 none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  opacity: 0.8;\n  outline: none;\n  transition: opacity 0.3s;\n}\n.graph-explorer-halo-link__button:hover {\n  opacity: 1;\n}\n.graph-explorer-halo-link__button[disabled] {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.graph-explorer-halo-link__edit {\n  background-color: #ccc;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 60%;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  background-image: url(\"../images/font-awesome/edit.svg\");\n}\n.graph-explorer-halo-link__delete {\n  background-color: #ccc;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 60%;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  background-image: url(\"../images/font-awesome/trash-alt.svg\");\n}\n.graph-explorer-halo-link__spinner {\n  position: absolute;\n}\n.graph-explorer-halo-link__edit-label-button {\n  background: transparent url(\"../images/font-awesome/pen-square-solid.svg\") no-repeat;\n  background-size: cover;\n  border: 0 none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  margin-left: 5px;\n  outline: none;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.graph-explorer-halo-link__edit-label-button:hover {\n  opacity: 1;\n}\n\n.graph-explorer-instances-search {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n.graph-explorer-instances-search__criteria {\n  flex-shrink: 0;\n  margin: 10px 0 10px 0;\n}\n.graph-explorer-instances-search__criterions {\n  padding-left: 15px;\n  margin-bottom: 10px;\n}\n.graph-explorer-instances-search__criterions:empty {\n  margin-bottom: 0;\n}\n.graph-explorer-instances-search__criterion {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.graph-explorer-instances-search__criterion-class {\n  border: black 1px dashed;\n  background: rgb(255, 210, 33);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.graph-explorer-instances-search__criterion-element {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.graph-explorer-instances-search__criterion-link-type {\n  border: black 1px dashed;\n  background: rgb(202, 255, 206);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.graph-explorer-instances-search__link-direction {\n  height: 1em;\n  opacity: 0.5;\n}\n.graph-explorer-instances-search__criterion-remove {\n  float: right;\n  margin: 0 10px 4px 4px;\n}\n.graph-explorer-instances-search__text-criteria {\n  margin: 0 10px;\n}\n.graph-explorer-instances-search__rest {\n  padding: 10px 10px 0 10px;\n  border-top: 1px solid rgb(221, 221, 221);\n}\n.graph-explorer-instances-search__results {\n  padding-left: 0;\n  padding-top: 10px;\n  margin: 0 10px 0 10px;\n  outline: none;\n}\n.graph-explorer-instances-search[data-state=finished] .graph-explorer-instances-search__results:empty:before {\n  content: \"No items correspond to the specified criteria.\";\n  font-style: italic;\n}\n.graph-explorer-instances-search__rest-end {\n  margin: 5px 0 10px 0;\n}\n.graph-explorer-instances-search__load-more {\n  width: 100%;\n}\n\n.link-types-toolbox {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n}\n.link-types-toolbox__heading {\n  padding: 10px;\n}\n.link-types-toolbox__searching-box {\n  display: flex;\n  align-items: center;\n}\n.link-types-toolbox__clearSearch {\n  margin-left: -25px;\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.link-types-toolbox__switch-all {\n  margin-top: 5px;\n}\n.link-types-toolbox__rest {\n  border-top: 1px solid #dddddd;\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.link-types-toolbox .panel-heading {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n}\n\n.link-types-toolbox ul {\n  margin-bottom: 0;\n}\n\n.link-types-toolbox .links-heading {\n  margin-left: 0.4em;\n}\n\n.link-types-toolbox .links-heading span {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n  line-height: 1.3;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls {\n  padding: 5px 15px;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls > span {\n  padding-left: 0.3em;\n}\n\n.graph-explorer-list-group .linkInToolBox {\n  padding: 0 0 0 5px;\n  word-break: break-word;\n}\n\n.linkInToolBox > div {\n  display: inline;\n}\n.linkInToolBox__new-tag {\n  margin-left: 0.5em;\n  white-space: normal;\n  word-wrap: normal;\n  border-radius: 2px;\n  padding: 0 5px;\n  background: orange;\n}\n.linkInToolBox .graph-explorer-badge {\n  display: none;\n  margin-left: 0.5em;\n  white-space: normal;\n  word-wrap: normal;\n}\n.linkInToolBox .link-title {\n  font-size: 16px;\n  color: black;\n  display: inline;\n}\n.linkInToolBox .graph-explorer-btn-group {\n  float: left;\n  margin-top: 2px;\n  margin-right: 6px;\n  margin-bottom: 2px;\n}\n.linkInToolBox .graph-explorer-btn.graph-explorer-btn-default {\n  border-color: rgb(195, 195, 195);\n}\n.linkInToolBox__filter-button {\n  display: none;\n  float: right;\n  background-image: url(\"../images/add-to-filter.png\");\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  margin: 3px;\n  cursor: pointer;\n  opacity: 0.4;\n  transition: opacity 200ms 0ms;\n}\n.linkInToolBox:hover .linkInToolBox__filter-button {\n  opacity: 1;\n  transition: opacity 200ms 0ms;\n}\n\n.connected-links .linkInToolBox .graph-explorer-badge {\n  /* show connection count badge only in \"Connected to Element\" list */\n  display: inline;\n}\n\n.connected-links .linkInToolBox__filter-button {\n  /* show filter button only in \"Connected to Element\" list */\n  display: inline;\n}\n\n.graph-explorer-list-element-view {\n  position: relative;\n  display: block;\n  background: #808080;\n  padding: 1px 1px 1px 10px;\n  border-radius: 2px;\n  margin: 0 0 2px 0;\n  opacity: 1;\n  cursor: move;\n  user-select: none;\n}\n.graph-explorer-list-element-view--disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.graph-explorer-list-element-view__label {\n  background: white;\n  border-radius: 0 2px 2px 0;\n  font-family: \"Andale Mono\", sans-serif;\n  font-size: 15px;\n  min-height: 1.3em;\n  padding-left: 7px;\n  padding-right: 5px;\n  overflow-wrap: break-word;\n}\n\n.graph-explorer-text-highlight {\n  font-weight: bold;\n}\n\n.graph-explorer-navigator {\n  display: block;\n  position: absolute;\n  bottom: 25px;\n  right: 25px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  transition: width 0.3s, height 0.3s;\n}\n.graph-explorer .graph-explorer-navigator {\n  box-sizing: content-box;\n}\n.graph-explorer-navigator--collapsed {\n  width: 26px;\n  height: 26px;\n}\n.graph-explorer-navigator > canvas {\n  transition: opacity 0.3s;\n}\n.graph-explorer-navigator--expanded > canvas {\n  opacity: 1;\n}\n.graph-explorer-navigator--collapsed > canvas {\n  opacity: 0;\n}\n.graph-explorer-navigator__toggle {\n  position: absolute;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 4px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.graph-explorer-navigator__toggle:hover {\n  opacity: 1;\n}\n.graph-explorer-navigator--expanded .graph-explorer-navigator__toggle {\n  top: 5px;\n  left: 5px;\n}\n.graph-explorer-navigator--collapsed .graph-explorer-navigator__toggle {\n  top: 0px;\n  left: 0px;\n}\n.graph-explorer-navigator__toggle-icon {\n  width: 18px;\n  height: 18px;\n  background-size: 18px 18px;\n  background-repeat: no-repeat;\n}\n.graph-explorer-navigator--expanded .graph-explorer-navigator__toggle-icon {\n  background-image: url(\"../images/font-awesome/minus-square-regular.svg\");\n}\n.graph-explorer-navigator--collapsed .graph-explorer-navigator__toggle-icon {\n  background-image: url(\"../images/font-awesome/plus-square-regular.svg\");\n}\n\n@keyframes graph-explorer-progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.graph-explorer-progress-bar {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n  width: 100%;\n  background-color: #f5f5f5;\n  background-image: linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%);\n  background-repeat: repeat-x;\n  overflow: hidden;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.graph-explorer-progress-bar__bar {\n  float: left;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  transition: width 0.6s ease;\n  background-color: #337ab7;\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-repeat: repeat-x;\n  background-size: 40px 40px;\n  animation: graph-explorer-progress-bar-stripes 2s linear infinite;\n}\n.graph-explorer-progress-bar--error .graph-explorer-progress-bar__bar {\n  background-color: #E72F2F;\n}\n.graph-explorer-progress-bar--loading, .graph-explorer-progress-bar--error {\n  /* property name | duration | delay */\n  transition: height 300ms 300ms;\n}\n.graph-explorer-progress-bar--completed {\n  /* property name | duration | delay */\n  transition: height 200ms 0ms;\n}\n\n.graph-explorer-search-results {\n  margin: 0;\n  padding: 0;\n  outline: none;\n}\n\n.graph-explorer-accordion {\n  flex: auto;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.graph-explorer-accordion--scrollable {\n  overflow: auto;\n}\n.graph-explorer-accordion--vertical {\n  flex-direction: column;\n}\n.graph-explorer-accordion--vertical:not(.graph-explorer-accordion--resizing) > .graph-explorer-accordion-item {\n  transition: height 0.3s ease-in-out;\n}\n\n.graph-explorer-accordion-item {\n  display: flex;\n  position: relative;\n  flex: auto;\n}\n.graph-explorer-accordion-item--resizing > .graph-explorer-accordion-item__handle, .graph-explorer-accordion-item__handle:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.graph-explorer-accordion-item--vertical {\n  border-top: 1px solid lightgray;\n}\n.graph-explorer-accordion-item--vertical:first-child {\n  border-top-width: 0;\n}\n.graph-explorer-accordion-item--horizontal {\n  border-right: 1px solid lightgray;\n}\n.graph-explorer-accordion-item--horizontal:last-child {\n  border-right-width: 0;\n}\n.graph-explorer-accordion-item__handle {\n  position: absolute;\n  z-index: 2;\n}\n.graph-explorer-accordion-item__handle-vertical {\n  height: 5px;\n  bottom: -2.5px;\n  left: 0;\n  width: 100%;\n  cursor: ns-resize;\n}\n.graph-explorer-accordion-item__handle-horizontal {\n  height: 100%;\n  top: 0;\n  right: -2.5px;\n  width: 5px;\n  cursor: ew-resize;\n}\n.graph-explorer-accordion-item__handle-btn {\n  background: #fff;\n  border: 2px solid #17b;\n  box-shadow: 0 0 0 1px rgba(9, 30, 66, 0.08), 0 2px 4px 1px rgba(9, 30, 66, 0.08);\n  border-radius: 10px;\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  top: 50%;\n  margin-top: -10px;\n  width: 20px;\n  z-index: 20;\n  transition: 0.3s;\n}\n.graph-explorer-accordion-item__handle-btn::before {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  content: \"\";\n  height: 8px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -4px;\n  margin-left: -4px;\n  width: 8px;\n  transition: background 0.3s;\n}\n.graph-explorer-accordion-item__handle-btn:hover {\n  background: #17b;\n}\n.graph-explorer-accordion-item__handle-btn-left {\n  left: 100%;\n  margin-left: -10px;\n}\n.graph-explorer-accordion-item__handle-btn-left:before {\n  background-image: url(\"../images/arrow-left.png\");\n}\n.graph-explorer-accordion-item__handle-btn-left:hover:before {\n  background-image: url(\"../images/arrow-left1.png\");\n}\n.graph-explorer-accordion-item__handle-btn-right {\n  right: 100%;\n  margin-right: -10px;\n}\n.graph-explorer-accordion-item__handle-btn-right:before {\n  background-image: url(\"../images/arrow-right.png\");\n}\n.graph-explorer-accordion-item__handle-btn-right:hover:before {\n  background-image: url(\"../images/arrow-right1.png\");\n}\n.graph-explorer-accordion-item--collapsed .graph-explorer-accordion-item__handle-btn:before {\n  transform: rotate(180deg);\n}\n.graph-explorer-accordion-item__inner {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.graph-explorer-accordion-item__body {\n  flex: 1 1 0px;\n  display: flex;\n  flex-direction: column;\n}\n.graph-explorer-accordion-item__header {\n  padding-left: 20px;\n  position: relative;\n  flex-shrink: 0;\n  font-size: 16px;\n  background: #E4E4E4;\n  cursor: default;\n  /* unselectable */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.graph-explorer-accordion-item__header:before {\n  border-top: 6px solid #555555;\n  border-left: 3.5px solid transparent;\n  border-right: 3.5px solid transparent;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 7px;\n  margin-top: -3px;\n  -webkit-transition: 0.1s;\n  -moz-transition: 0.1s;\n  transition: 0.1s;\n}\n.graph-explorer-accordion-item--collapsed .graph-explorer-accordion-item__header:before {\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n.graph-explorer-accordion-item--collapsed .graph-explorer-accordion-item__body {\n  display: none;\n}\n\n.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle,\n.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle {\n  height: 8px;\n  width: 100%;\n  top: initial;\n  left: 0;\n  cursor: ns-resize;\n}\n.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle-btn,\n.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle-btn {\n  height: 100%;\n  width: 40px;\n  top: 0;\n  left: 50%;\n  margin-left: -20px;\n  margin-top: 0px;\n}\n\n.graph-explorer-drag-resizable-column {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.graph-explorer-drag-resizable-column__handle {\n  background: #fff url(\"../images/resizable-column-handle.png\") repeat;\n  width: 8px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: initial;\n  z-index: 2;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n  cursor: ew-resize;\n}\n.graph-explorer-drag-resizable-column__handle-btn {\n  background: #eee;\n  cursor: pointer;\n  height: 40px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  margin-top: -20px;\n  width: 100%;\n  z-index: 1;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n.graph-explorer-drag-resizable-column__handle-btn::before {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  content: \"\";\n  height: 6px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -3px;\n  margin-left: -3px;\n  width: 6px;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n.graph-explorer-drag-resizable-column__handle-btn:hover {\n  background: #b3b3b3;\n  transform: scale(1.2);\n}\n.graph-explorer-drag-resizable-column--closed .graph-explorer-drag-resizable-column__handle-btn::before {\n  transform: rotate(180deg);\n}\n.graph-explorer-drag-resizable-column--docked-left {\n  margin-right: 8px;\n}\n.graph-explorer-drag-resizable-column--docked-left .graph-explorer-drag-resizable-column__handle {\n  right: -8px;\n}\n.graph-explorer-drag-resizable-column--docked-left .graph-explorer-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-left.png\");\n}\n.graph-explorer-drag-resizable-column--docked-left .graph-explorer-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-left1.png\");\n}\n.graph-explorer-drag-resizable-column--docked-right {\n  margin-left: 8px;\n}\n.graph-explorer-drag-resizable-column--docked-right .graph-explorer-drag-resizable-column__handle {\n  left: -8px;\n}\n.graph-explorer-drag-resizable-column--docked-right .graph-explorer-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-right.png\");\n}\n.graph-explorer-drag-resizable-column--docked-right .graph-explorer-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-right1.png\");\n}\n.graph-explorer-drag-resizable-column--docked-top {\n  margin-bottom: 8px;\n}\n.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle {\n  bottom: -8px;\n}\n.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-top.png\");\n}\n.graph-explorer-drag-resizable-column--docked-top .graph-explorer-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-top1.png\");\n}\n.graph-explorer-drag-resizable-column--docked-bottom {\n  margin-top: 8px;\n}\n.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle {\n  top: -8px;\n}\n.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-bottom.png\");\n}\n.graph-explorer-drag-resizable-column--docked-bottom .graph-explorer-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-bottom1.png\");\n}\n\n.introjs-tooltiptext {\n  color: #333;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n\n.graph-explorer-toolbar__language-selector {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.graph-explorer-toolbar__language-selector > label {\n  margin-right: 5px;\n}\n.graph-explorer-toolbar__language-selector > label > span {\n  vertical-align: middle;\n}\n.graph-explorer-toolbar__language-selector > select {\n  height: 30px;\n}\n.graph-explorer-toolbar__toggle {\n  line-height: 1;\n}\n.graph-explorer-toolbar__toggle:after {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  content: \"\";\n  display: block;\n  height: 12px;\n  margin: 3px 0;\n  width: 12px;\n}\n.graph-explorer-toolbar__toggle-left:after {\n  background-image: url(\"../images/left-panel.svg\");\n}\n.graph-explorer-toolbar__toggle-right:after {\n  background-image: url(\"../images/right-panel.svg\");\n}\n.graph-explorer-toolbar__toggle.active {\n  border-color: #c3c3c3;\n}\n.graph-explorer-toolbar__toggle-left.active:after {\n  background-image: url(\"../images/left-panel-active.svg\");\n}\n.graph-explorer-toolbar__toggle-right.active:after {\n  background-image: url(\"../images/right-panel-active.svg\");\n}\n.graph-explorer-toolbar__layout-group {\n  float: left;\n  margin-left: 5px;\n  height: 30px;\n}\n.graph-explorer-toolbar__layout-group > label {\n  margin-right: 5px;\n}\n.graph-explorer-toolbar__layout-group .btn-group, .graph-explorer-toolbar__layout-group button {\n  height: 100%;\n}\n\n.graph-explorer-toolbar .graph-explorer-toolbar__undo,\n.graph-explorer-toolbar .graph-explorer-toolbar__redo {\n  display: none;\n}\n\n.graph-explorer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n  white-space: initial;\n  color: #333;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n.graph-explorer *, .graph-explorer *:before, .graph-explorer *:after {\n  box-sizing: inherit;\n}\n.graph-explorer__toolbar-widget {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n}\n.graph-explorer__workspace {\n  display: flex;\n  flex: auto;\n  overflow: hidden;\n  flex-direction: column;\n}\n.graph-explorer__main-panel {\n  display: flex;\n  flex: auto;\n  overflow: hidden;\n  width: 0;\n}\n.graph-explorer--unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.graph-explorer--horizontal-resizing * {\n  cursor: ew-resize !important;\n}\n.graph-explorer--vertical-resizing * {\n  cursor: ns-resize !important;\n}\n.graph-explorer h4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.graph-explorer select {\n  color: inherit;\n  margin: 0;\n  font: inherit;\n  line-height: inherit;\n  text-transform: none;\n}\n.graph-explorer hr {\n  border: 0;\n  border-top: 1px solid #eee;\n  height: 0;\n}\n\n.graph-explorer-scrollable {\n  flex: 1 1 0px;\n  overflow-y: scroll;\n}\n\n.graph-explorer-scrollable > * {\n  position: relative;\n}\n\n.jstree-icon.jstree-themeicon.jstree-themeicon-custom {\n  background-size: contain !important;\n}\n\n.graph-explorer-default-template, .graph-explorer-group-template__wrap {\n  max-width: 450px;\n  float: left;\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 1px;\n}\n.graph-explorer-default-template__thumbnail {\n  text-align: center;\n}\n.graph-explorer-default-template__thumbnail > img {\n  max-width: 200px;\n}\n.graph-explorer-default-template[data-expanded=true] .graph-explorer-default-template__thumbnail > img, [data-expanded=true].graph-explorer-group-template__wrap .graph-explorer-default-template__thumbnail > img {\n  max-width: 350px;\n}\n\n.graph-explorer-default-template_type-line, .graph-explorer-group-template__type-line {\n  padding: 0px 7px;\n  color: white;\n  height: 18px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  display: flex;\n  align-items: baseline;\n  margin-top: -3px;\n}\n\ndiv.graph-explorer-default-template_type-line__icon, div.graph-explorer-group-template__type-line-icon {\n  position: inherit !important;\n  margin-right: 4px;\n}\n\n.graph-explorer-default-template_type-line_text-container, .graph-explorer-group-template__type-line-text-container {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 0;\n}\n\n.graph-explorer-default-template_type-line_text-container__text, .graph-explorer-group-template__type-line-text {\n  display: inline;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.graph-explorer-default-template_body, .graph-explorer-group-template__body {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  background: white;\n  padding: 7px 10px 8px 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-explorer-default-template_body__label, .graph-explorer-group-template__label {\n  font-size: 19px;\n  font-weight: 100;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0;\n  white-space: nowrap;\n  word-wrap: break-word;\n}\n\n.graph-explorer-default-template_body_expander {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n\n.graph-explorer-default-template_body_expander__iri_label {\n  font-size: 12px;\n  font-weight: 100;\n  margin-right: 15px;\n  color: #b6b6b6;\n}\n\n.graph-explorer-default-template_body_expander_iri {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.graph-explorer-default-template_body_expander_iri__link {\n  color: #b6b6b6;\n}\n\n.graph-explorer-default-template_body_expander__hr {\n  margin: 5px 0px 5px 0px;\n}\n\n.graph-explorer-default-template_body_expander_property-table {\n  font-size: 15px;\n  font-weight: 100;\n  margin-bottom: 5px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row {\n  white-space: nowrap;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row__key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row_key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row_key_values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row_key_values__value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n\n.graph-explorer-group-template {\n  overflow: hidden;\n}\n.graph-explorer-group-template__wrap {\n  max-width: none;\n}\n.graph-explorer-group-template__body {\n  overflow: visible;\n}\n.graph-explorer-group-template__embedded-layer {\n  margin-top: 7px;\n}\n.graph-explorer-group-template .graph-explorer-paper__canvas {\n  border-color: #fff;\n}\n\n.graph-explorer-standard-template {\n  min-width: 180px;\n  max-width: 400px;\n  float: left;\n}\n.graph-explorer-standard-template__main {\n  border-radius: 2px;\n  border: 1px solid;\n}\n.graph-explorer-standard-template__body {\n  margin-left: 8px;\n  border-radius: 0 2px 2px 0;\n  border-left: 1px solid;\n  padding: 3px 0;\n  background: #fafaf9;\n}\n.graph-explorer-standard-template__body-horizontal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.graph-explorer-standard-template__body-content {\n  flex-grow: 1;\n  min-width: 0;\n  margin-right: 12px;\n}\n.graph-explorer-standard-template__label {\n  font-size: 19px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.graph-explorer-standard-template__thumbnail {\n  font-size: 26px;\n  margin: 5px 10px;\n  flex-shrink: 0;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.graph-explorer-standard-template__thumbnail-image {\n  max-height: 100%;\n  max-width: 100%;\n}\n.graph-explorer-standard-template__thumbnail-icon {\n  max-height: 26px;\n  max-width: 26px;\n}\n.graph-explorer-standard-template__photo {\n  border-bottom: 1px solid;\n}\n.graph-explorer-standard-template__photo-image {\n  width: 100%;\n  border-radius: 2px 2px 0 0;\n}\n.graph-explorer-standard-template__type {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 11px;\n  font-style: italic;\n  color: #999;\n  display: flex;\n}\n.graph-explorer-standard-template__type-value {\n  width: 0;\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.graph-explorer-standard-template__iri {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n.graph-explorer-standard-template__iri-key {\n  font-size: 12px;\n  margin-right: 4px;\n  color: #b6b6b6;\n}\n.graph-explorer-standard-template__iri-value {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.graph-explorer-standard-template__iri-value a {\n  color: #b6b6b6;\n}\n.graph-explorer-standard-template__hr {\n  margin: 5px 0;\n}\n.graph-explorer-standard-template__properties {\n  font-size: 15px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.graph-explorer-standard-template__propertites-row {\n  white-space: nowrap;\n}\n.graph-explorer-standard-template__properties-key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n.graph-explorer-standard-template__properties-values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.graph-explorer-standard-template__properties-value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n.graph-explorer-standard-template__pinned-props {\n  border-top: 1px solid;\n  margin: 0 5px;\n}\n.graph-explorer-standard-template__dropdown {\n  border-radius: 2px;\n  background-color: white;\n  margin-top: 5px;\n  border: 1px solid;\n}\n.graph-explorer-standard-template__dropdown-content {\n  width: 100%;\n  padding: 9px;\n}\n.graph-explorer-standard-template__actions {\n  display: flex;\n  justify-content: space-between;\n}\n.graph-explorer-standard-template__actions button {\n  padding: 5px;\n  min-width: 60px;\n}",".clearfix {\n\n  &:before, &:after {\n    display: table;\n    content: \"\";\n  }\n\n  &:after {\n    clear: both;\n  }\n}\n",".graph-explorer-label {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n","@use \"sass:color\";\n.graph-explorer-btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  text-transform: none;\n  transition: background-color 0.3s;\n\n  &[disabled] {\n    cursor: not-allowed;\n    opacity: .65;\n  }\n}\n\n\n.graph-explorer-btn-default {\n  background-color: #fff;\n  border-color: #ccc;\n  color: #333;\n\n  &:hover {\n    background-color: #e0e0e0;\n  }\n\n  &.active {\n    background-color: #e0e0e0;\n    border-color: #dbdbdb;\n  }\n\n  &.active:hover {\n    background-color: #d4d4d4;\n    border-color: #8c8c8c;\n  }\n\n  &[disabled], &[disabled]:hover, &[disabled].active, &[disabled].active:hover {\n    background-color: #e0e0e0;\n  }\n}\n\n.graph-explorer-btn-primary {\n  color: rgb(255, 255, 255);\n  background-color: rgb(51, 122, 183);\n  border-color: #245580;\n\n  &:hover, &:focus, &:active {\n    background-color: #265a88;\n  }\n\n  &:hover, &:focus {\n    border-color: #204d74;\n  }\n\n  &.active {\n    border-color: #245580;\n  }\n\n  &[disabled], &[disabled]:hover, &[disabled]:focus, &[disabled]:active, &[disabled].active {\n    background-color: #265a88;\n  }\n}\n\n.graph-explorer-btn-success {\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n  color: #fff;\n  transition: 0.3s;\n\n  &:hover {\n    background: color.adjust(#5cb85c, $lightness: -8%);\n  }\n}\n\n.graph-explorer-btn-danger {\n  background-color: #c9302c;\n  border-color: #c9302c;\n  color: #fff;\n  transition: 0.3s;\n\n  &:hover {\n    background: color.adjust(#c9302c, $lightness: -8%);\n  }\n}\n",".graph-explorer-btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n\n  > .graph-explorer-btn, > .graph-explorer-btn-group {\n    position: relative;\n    float: left;\n  }\n\n  > .graph-explorer-btn:hover,\n  > .graph-explorer-btn:focus,\n  > .graph-explorer-btn.active,\n  > .graph-explorer-btn.active:hover {\n    z-index: 2;\n  }\n\n  .graph-explorer-btn + .graph-explorer-btn,\n  .graph-explorer-btn + .graph-explorer-btn-group,\n  .graph-explorer-btn-group + .graph-explorer-btn,\n  .graph-explorer-btn-group + .graph-explorer-btn-group {\n    margin-left: -1px;\n  }\n\n  > .graph-explorer-btn:first-child {\n    margin-left: 0;\n  }\n\n  &-sm > .graph-explorer-btn {\n    font-size: 12px;\n    line-height: 1.5;\n    padding: 5px 10px;\n  }\n\n  &-xs > .graph-explorer-btn {\n    font-size: 12px;\n    line-height: 1.5;\n    padding: 1px 5px;\n  }\n}\n",".graph-explorer-form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  margin: 0;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background: #fff;\n  border: 1px solid #ccc;\n  transition: border-color ease-in-out .15s;\n\n  &:focus {\n    border-color: #66afe9;\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: #eee;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n",".graph-explorer-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n\n  .graph-explorer-form-control {\n    display: table-cell;\n    position: relative;\n    z-index: 2;\n    float: left;\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n  .graph-explorer-form-control:first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n}\n\n.graph-explorer-input-group-btn {\n  display: table-cell;\n  width: 1%;\n  vertical-align: middle;\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n\n  &:last-child > .graph-explorer-btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    z-index: 2;\n    margin-left: -1px;\n  }\n}\n",".graph-explorer-list-group {\n  margin: 0;\n  padding: 0;\n}\n\n.graph-explorer-list-group-item:last-child {\n  margin-bottom: 0;\n}\n\n.graph-explorer-list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n",".graph-explorer-badge {\n  display: inline-block;\n  min-width: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: rgb(119, 119, 119);\n  padding: 3px 7px;\n  border-radius: 10px;\n}\n",".graph-explorer-overlayed-element {\n  cursor: move;\n  outline: none;\n}\n\n.graph-explorer-overlayed-element,\n.graph-explorer-exported-element {\n  // set defaults for all inherited properties\n  box-sizing: border-box;\n  color: black;\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n\n  // http://stackoverflow.com/questions/6664460/line-height-affects-images\n  img { vertical-align: middle; }\n}\n\n.graph-explorer-exported-element {\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n}\n\n.graph-explorer-overlayed-element--blurred {\n  filter: grayscale(100%);\n  opacity: 0.5;\n}\n",".graph-explorer-link {\n  &__wrap {\n    stroke-width: 12px;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n    stroke: transparent;\n    fill: none;\n  }\n  &:hover &__wrap {\n    stroke: rgba(140, 140, 140, 0.44);\n  }\n\n  &__vertex {\n    cursor: all-scroll;\n  }\n  &:not(:hover) &__vertex {\n    fill: transparent;\n  }\n\n  &__vertex-tools {\n    opacity: 0;\n    cursor: pointer;\n    > circle { fill: gray; }\n    > path { stroke: white; }\n    &:hover {\n      > circle { fill: black; }\n    }\n  }\n  &:hover &__vertex-tools {\n    opacity: 0.8;\n  }\n\n  &--blurred {\n    opacity: 0.5;\n  }\n}\n",".graph-explorer-paper-area {\n  flex: auto;\n  width: 0;\n  display: flex;\n  position: relative;\n  cursor: default;\n  background: #fff;\n\n  &__area {\n    flex: auto;\n    overflow: hidden;\n  }\n\n  &__widgets {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n\n  &__watermark {\n    background-size: cover;\n    width: 8%;\n    max-width: 130px;\n    min-width: 50px;\n    position: absolute;\n    top: 15px;\n    right: 25px;\n    cursor: pointer;\n    opacity: 0.3;\n    transition: opacity 0.3s;\n\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n\n  &--hide-scrollbars {\n    overflow: hidden;\n  }\n}\n\n.graph-explorer-paper {\n  position: relative;\n}\n\n.graph-explorer-exported-watermark {\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n",".graph-explorer-paper-area--animated {\n    .graph-explorer-overlayed-element {\n        transition: transform 0.5s ease-in-out;\n    }\n    .graph-explorer-link-layer, .graph-explorer-paper-area__widgets {\n        transition: none;\n        opacity: 0;\n    }\n}\n\n.graph-explorer-link-layer, .graph-explorer-paper-area__widgets {\n    transition: opacity 0.5s ease-in-out;\n}\n",".graph-explorer-loading-widget {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 10;\n}\n",".graph-explorer-authoring-state {\n  &__item-error {\n    align-self: flex-end;\n    margin: 0px 5px;\n    display: flex;\n    align-items: center;\n    cursor: help;\n  }\n\n  &__item-error-icon {\n    background: url(\"../images/font-awesome/exclamation-triangle.svg\");\n    height: 15px;\n    width: 17px;\n  }\n\n  &__state-label {\n    font-weight: bold;\n    margin-right: 5px;\n  }\n\n  &__state-cancel {\n    color: #3f87a6;\n    cursor: pointer;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &__state-indicator {\n    position: absolute;\n  }\n  &__state-indicator-container {\n    position: relative;\n  }\n  &__state-indicator-body {\n    position: absolute;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.7);\n    border-radius: 5px;\n  }\n}\n",".graph-explorer-authoring-tools {\n  margin: 10px;\n\n  &__create-entity {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    white-space: normal;\n  }\n\n  &__type-label {\n    color: black;\n    border: black 1px dashed;\n    background: rgb(255, 210, 33);\n    padding: 0 .5em 0 .5em;\n    word-wrap: break-word;\n  }\n}\n",".graph-explorer-class-tree {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n\n  &__filter {\n    flex-shrink: 0;\n    margin: 10px 0 10px 0;\n  }\n\n  &__filter-group {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  &__only-creatable {\n    display: block;\n    margin-top: 5px;\n  }\n\n  &__tree {\n    border-top: 1px solid rgb(221, 221, 221);\n  }\n\n  &__spinner {\n    align-self: center;\n    /* center vertically in flexbox */\n    margin: auto;\n  }\n}\n\n.graph-explorer-class-leaf {\n  margin: 1px 0;\n\n  &__row {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    user-select: none;\n    > * { flex-shrink: 0; }\n  }\n\n  &__body {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    font-size: 15px;\n    padding: 1px;\n    border: 1px solid;\n    border-color: transparent;\n    &:hover {\n      background: #dcebff91;\n      border-color: #ccefff;\n      cursor: pointer;\n    }\n    &--selected {\n      background-color: #beebff;\n      border-color: #8edcff;\n    }\n  }\n\n  &__icon-container {\n    height: 20px;\n  }\n\n  &__icon {\n    display: block;\n    height: 100%;\n  }\n\n  &__label {\n    margin-left: 5px;\n    color: black;\n  }\n\n  &__highlighted-term {\n    font-weight: bold;\n  }\n\n  &__count {\n    margin-left: 5px;\n  }\n\n  &__children {\n    margin-left: 20px;\n  }\n\n  &__no-toggle {\n    display: inline-block;\n    width: 22px;\n    height: 22px;\n  }\n\n  &__toggle {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    margin: 5px;\n    &:hover:not(:empty) {\n      background: #dcebff91;\n      cursor: pointer;\n    }\n  }\n\n  &__toggle-icon {\n    display: block;\n    height: 100%;\n  }\n\n  &__create {\n    margin-left: 5px;\n    > button {\n      cursor: move;\n    }\n  }\n}\n",".graph-explorer-connections-menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &__sort-switch {\n    display: none;\n  }\n\n  &__sort-switch:checked + &__sort-switch-label {\n    color: #337ab7;\n    opacity: 1;\n  }\n\n  &__sort-switch-label {\n    cursor: pointer;\n    display: block;\n    margin: 0;\n    opacity: 0.4;\n    text-align: center;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  &__search-line-input {\n    flex: 1 1 100%;\n  }\n}\n\n.graph-explorer-connections-menu_bread-crumbs {\n  padding: 10px;\n  padding-bottom: 0px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 27px;\n  min-height: 27px;\n  flex-grow: 0;\n}\n\n.graph-explorer-connections-menu__title-label {\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n\n.graph-explorer-connections-menu_search-line {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.graph-explorer-connections-menu_search-line-sort-switches {\n  flex: 0 0 20px;\n  margin-left: 10px;\n}\n\n.graph-explorer-connections-menu_links-list {\n  padding: 5px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-top: 1px solid #dbdbdb;\n  flex-grow: 1;\n  margin: 0;\n}\n\n.ocm_links-list-empty {\n  display: flex;\n  align-items: center;\n}\n\n.graph-explorer-connections-menu_links-list__empty {\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n  text-align: center;\n}\n\n.graph-explorer-connections-menu__loading,\n.graph-explorer-connections-menu__error {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n}\n.graph-explorer-connections-menu__loading-objects {\n  border: 1px solid gray;\n  flex-grow: 1;\n  box-shadow: inset 0px 0px 23px -8px gray;\n  background-color: whitesmoke;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n\n.graph-explorer-connections-menu__move-to-filter {\n  display: flex;\n  padding: 5px 10px;\n  user-select: none;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #e6e6e6;\n  }\n}\n\n.link-in-popup-menu {\n  display: flex;\n  overflow: hidden;\n  padding: 0 5px 0 0;\n  align-items: center;\n  margin-bottom: 4px;\n  background: #f7f7f7;\n\n  &__link-title {\n    flex-grow: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    margin: 5px 0px 5px 5px;\n  }\n\n  &__count {\n    flex-shrink: 0;\n    margin-left: 10px;\n  }\n\n  &__navigate-button {\n    float: right;\n    background-image: url(\"../images/expand-link.png\");\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n    margin-left: 10px;\n    min-width: 16px;\n    background-size: cover;\n    &:hover { opacity: 1; }\n  }\n\n  &__filter-button {\n    background-image: url(\"../images/add-to-filter.png\");\n    background-size: 20px 20px;\n    width: 20px;\n    height: 20px;\n    opacity: 0.4;\n    margin-left: 10px;\n    &:hover { opacity: 1; }\n  }\n\n  &:hover {\n    background-color: #e2e2e2;\n  }\n}\n\n.link-in-popup-menu_direction {\n    background: rgba(219, 219, 219, 0.35);\n    min-height: 30px;\n    padding: 5px 0px 5px 10px;\n    display: flex;\n    align-items: center;\n}\n\n.link-in-popup-menu_direction__in-direction {\n  background: url(\"../images/direction-in.png\") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 14px 0 0;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.link-in-popup-menu_direction__out-direction {\n  background: url(\"../images/direction-out.png\") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 8px 0 6px;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.graph-explorer-connections-menu_links-list__loading {\n  text-align: center;\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n}\n\n.graph-explorer-connections-menu_links-list__hr {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.graph-explorer-connections-menu_objects-panel {\n  flex-grow: 1;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n\n.graph-explorer-connections-menu_objects-panel__select-all {\n    white-space: nowrap;\n    margin-bottom: 5px;\n    display: flex;\n\n    input {\n      margin-right: 5px;\n      &:disabled { opacity: 0.3 }\n    }\n}\n\n.graph-explorer-connections-menu_objects-panel_bottom-panel {\n  height: 25px;\n  white-space: nowrap;\n  display: flex;\n  justify-content: space-between;\n}\n\n.graph-explorer-connections-menu_objects-panel_bottom-panel__count-label {\n  height: 25px;\n  float: left;\n  padding: 0px 5px;\n  font-size: larger;\n  display: flex;\n  align-items: center;\n  max-width: 60%;\n}\n\n.graph-explorer-connections-menu_objects-panel_bottom-panel__extra-elements {\n  color: gray;\n  cursor: help;\n}\n\n.graph-explorer-btn.graph-explorer-connections-menu_objects-panel_bottom-panel__add-button {\n  height: 25px;\n  padding-top: 1px;\n  padding-bottom: 2px;\n}\n\n.graph-explorer-connections-menu_objects-panel_objects-list {\n  border: 1px solid gray;\n  height: 0;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.graph-explorer-connections-menu__link {\n  color: #337ab7;\n  cursor: pointer;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n",".graph-explorer-dialog {\n  background: #fff;\n  border: 1px solid #333;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  position: absolute;\n\n  &__caption {\n    font-weight: bold;\n    position: absolute;\n    top: -11px;\n    left: 10px;\n    background: white;\n    padding-left: 3px;\n    padding-right: 3px;\n    border-radius: 6px;\n  }\n\n  &__close-button {\n    background: transparent url(\"../images/font-awesome/times-circle-regular.svg\");\n    background-size: contain;\n    border: 0 none;\n    cursor: pointer;\n    display: block;\n    outline: none;\n    padding: 0;\n    position: absolute;\n    top: -22px;\n    right: -22px;\n    height: 20px;\n    width: 20px;\n\n    opacity: 0.5;\n    transition: 0.3s;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.graph-explorer-dialog__bottom-right-handle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 10px 10px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n  cursor: nwse-resize;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    right: 0;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0 5px 5px;\n    border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n  }\n\n  &:hover {\n    border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\n  }\n}\n\n.graph-explorer-dialog__bottom-handle, .graph-explorer-dialog__right-handle {\n  position: absolute;\n  opacity: 0;\n  background-color: black;\n\n  &:hover {\n    opacity: 0.1;\n  }\n}\n\n.graph-explorer-dialog__bottom-handle {\n  bottom: 0;\n  width: 100%;\n  height: 5px;\n  cursor: ns-resize;\n}\n\n.graph-explorer-dialog__right-handle {\n  top: 0;\n  right: 0;\n  width: 5px;\n  height: 100%;\n  cursor: ew-resize;\n}\n",".graph-explorer-edit-form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &__body {\n    overflow: auto;\n    padding: 10px;\n    flex: 1 1 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n  }\n\n  &__controls {\n    border-top: 1px solid #ccc;\n    padding: 10px;\n    text-align: right;\n    flex: 0 0 auto;\n  }\n\n  &__apply-button {\n    margin-right: 5px;\n  }\n\n  &__form-row {\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  &__element-selector {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__search {\n    flex-shrink: 0;\n    position: relative;\n  }\n\n  &__search-icon {\n    opacity: 0.6;\n    position: absolute;\n    top: 50%;\n    left: 10px;\n    margin-top: -7px;\n  }\n\n  &__search-input {\n    padding-left: 33px;\n  }\n\n  &__existing-elements-list {\n    flex: 1 1 0;\n    margin-top: 7px;\n    padding-right: 10px;\n    overflow-y: scroll;\n  }\n\n  &__separator {\n    margin: 7px 0;\n    overflow: hidden;\n    text-align: center;\n  }\n\n  &__separator-text {\n    color: #555;\n    display: inline-block;\n    font-size: 13px;\n    position: relative;\n\n    &:before, &:after {\n      content: \"\";\n      border-top: 1px solid;\n      position: absolute;\n      top: 50%;\n      margin: 0 10px;\n      width: 500px;\n    }\n\n    &:before {\n      left: 100%;\n    }\n\n    &:after {\n      right: 100%;\n    }\n  }\n\n  &__progress {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n\n  &__control-row {\n    position: relative;\n    padding-bottom: 18px;\n  }\n\n  &__control-error {\n    color: red;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n  }\n}\n",".graph-explorer-halo {\n  position: absolute;\n  pointer-events: none;\n\n  border: 1.5px dashed #d8956d;\n  border-radius: 2px;\n  box-shadow: 0 0 5px 0 #d8956d inset;\n\n  $buttonWidth: 20px;\n  $buttonHeight: 20px;\n  $buttonMargin: 2px;\n\n  @mixin halo-button {\n    position: absolute;\n    background-color: transparent;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    border: 0 none;\n    cursor: pointer;\n    outline: none;\n    padding: 0;\n    pointer-events: auto;\n    width: $buttonWidth;\n    height: $buttonHeight;\n\n    opacity: 0.5;\n    transition: opacity 0.3s;\n    &:hover {\n      opacity: 1;\n    }\n\n    &[disabled] {\n      cursor: not-allowed;\n      opacity: 0.2;\n    }\n  }\n\n  @mixin spinner {\n    position: absolute;\n    width: $buttonWidth;\n    height: $buttonHeight;\n  }\n\n  @mixin n-docked {\n    top: -($buttonHeight + $buttonMargin);\n    left: 50%;\n    margin-left: -(calc($buttonWidth / 2));\n  }\n\n  @mixin nw-docked {\n    top: -($buttonHeight + $buttonMargin);\n    left: -($buttonWidth + $buttonMargin);\n  }\n\n  @mixin ne-docked {\n    top: -($buttonHeight + $buttonMargin);\n    right: -($buttonWidth + $buttonMargin);\n  }\n\n  @mixin e-docked {\n    top: 50%;\n    margin-top: -(calc($buttonHeight / 2));\n    right: -($buttonWidth + $buttonMargin);\n  }\n\n  @mixin w-docked {\n    top: 50%;\n    margin-top: -(calc($buttonHeight / 2));\n    left: -($buttonWidth + $buttonMargin);\n  }\n\n  @mixin s-docked {\n    bottom: -($buttonHeight + $buttonMargin);\n    left: 50%;\n    margin-left: -(calc($buttonWidth / 2));\n  }\n\n  @mixin sw-docked {\n    bottom: -($buttonHeight + $buttonMargin);\n    left: -($buttonWidth + $buttonMargin);\n  }\n\n  @mixin se-docked {\n    bottom: -($buttonHeight + $buttonMargin);\n    right: -($buttonWidth + $buttonMargin);\n  }\n\n  &__navigate {\n    @include halo-button;\n    @include e-docked;\n\n    &--open {\n      background-image: url(\"../images/connections.svg\");\n    }\n\n    &--closed {\n      background-image: url(\"../images/close-connections.svg\");\n    }\n  }\n\n  &__folow {\n    @include halo-button;\n    @include w-docked;\n\n    background-image: url(\"../images/link.svg\");\n  }\n\n  &__remove {\n    @include halo-button;\n    @include ne-docked;\n    background-image: url(\"../images/delete.svg\");\n  }\n\n  &__expand {\n    @include halo-button;\n    @include s-docked;\n\n    &--open {\n      background-image: url(\"../images/expand-properties.png\");\n    }\n\n    &--closed {\n      background-image: url(\"../images/collapse-properties.png\");\n    }\n  }\n\n  &__add-to-filter {\n    @include halo-button;\n    @include se-docked;\n    background-image: url(\"../images/add-to-filter.png\");\n  }\n\n  &__revert {\n    @include halo-button;\n    @include n-docked;\n    background-image: url(\"../images/font-awesome/undo-solid.svg\");\n  }\n\n  &__establish-connection {\n    @include halo-button;\n    @include sw-docked;\n    background-image: url(\"../images/font-awesome/plug.svg\");\n  }\n\n  &__establish-connection-spinner {\n    @include spinner;\n    @include sw-docked;\n  }\n}\n",".graph-explorer-halo-link {\n\n  &__button {\n    background: transparent;\n    border: 0 none;\n    cursor: pointer;\n    padding: 0;\n    position: absolute;\n    opacity: 0.8;\n    outline: none;\n    transition: opacity 0.3s;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &[disabled] {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n  }\n\n  @mixin button {\n    background-color: #ccc;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 60%;\n    border-radius: 10px;\n    height: 20px;\n    width: 20px;\n  }\n\n  &__edit {\n    @include button;\n    background-image: url(\"../images/font-awesome/edit.svg\");\n  }\n\n  &__delete {\n    @include button;\n    background-image: url(\"../images/font-awesome/trash-alt.svg\");\n  }\n\n  &__spinner {\n    position: absolute;\n  }\n\n  &__edit-label-button {\n    background: transparent url(\"../images/font-awesome/pen-square-solid.svg\") no-repeat;\n    background-size: cover;\n    border: 0 none;\n    cursor: pointer;\n    padding: 0;\n    position: absolute;\n    margin-left: 5px;\n    outline: none;\n    opacity: 0.5;\n    transition: opacity 0.3s;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n",".graph-explorer-instances-search {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n\n  &__criteria {\n    flex-shrink: 0;\n    margin: 10px 0 10px 0;\n  }\n\n  &__criterions {\n    padding-left: 15px;\n    margin-bottom: 10px;\n    &:empty { margin-bottom: 0; }\n  }\n\n  &__criterion {\n    display: block;\n    position: relative;\n    width: 100%;\n  }\n\n  &__criterion-class {\n    border: black 1px dashed;\n    background: rgb(255, 210, 33);\n    padding: 0 .5em 0 .5em;\n    word-wrap: break-word;\n  }\n\n  &__criterion-element {\n    border: black 1px dashed;\n    background: rgb(255, 131, 92);\n    padding: 0 .5em 0 .5em;\n    word-wrap: break-word;\n  }\n\n  &__criterion-link-type {\n    border: black 1px dashed;\n    background: rgb(202, 255, 206);\n    padding: 0 .5em 0 .5em;\n    word-wrap: break-word;\n  }\n\n  &__link-direction {\n    height: 1em;\n    opacity: 0.5;\n  }\n\n  &__criterion-remove {\n    float: right;\n    margin: 0 10px 4px 4px;\n  }\n\n  &__text-criteria { margin: 0 10px; }\n\n  &__rest {\n    padding: 10px 10px 0 10px;\n    border-top: 1px solid rgb(221, 221, 221);\n  }\n\n  &__results {\n    padding-left: 0;\n    padding-top: 10px;\n    margin: 0 10px 0 10px;\n    outline: none;\n  }\n\n  &[data-state='finished'] &__results:empty:before {\n    content: 'No items correspond to the specified criteria.';\n    font-style: italic;\n  }\n\n  &__rest-end { margin: 5px 0 10px 0; }\n  &__load-more {\n    width: 100%;\n  }\n}\n",".link-types-toolbox {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n\n  &__heading {\n    padding: 10px;\n  }\n\n  &__searching-box {\n    display: flex;\n    align-items: center;\n  }\n\n  &__clearSearch {\n    margin-left: -25px;\n    -webkit-appearance: none;\n    padding: 0;\n    cursor: pointer;\n    background: 0 0;\n    border: 0;\n  }\n\n  &__switch-all {\n    margin-top: 5px;\n  }\n\n  &__rest {\n    border-top: 1px solid #dddddd;\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.link-types-toolbox .panel-heading {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n}\n\n.link-types-toolbox ul {\n  margin-bottom: 0;\n}\n.link-types-toolbox .links-heading {\n  margin-left: .4em;\n}\n.link-types-toolbox .links-heading span {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 .5em 0 .5em;\n  word-wrap: break-word;\n  line-height: 1.3;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls {\n  padding: 5px 15px;\n  font-size: 14px;\n  font-style: italic;\n}\n.link-types-toolbox__heading .link-types-toolbox-controls > span {\n  padding-left: .3em;\n}\n\n.graph-explorer-list-group .linkInToolBox {\n  padding: 0 0 0 5px;\n  word-break: break-word;\n}\n\n.linkInToolBox {\n  & > div { display: inline; }\n\n  &__new-tag {\n    margin-left: .5em;\n    white-space: normal;\n    word-wrap: normal;\n    border-radius: 2px;\n    padding: 0 5px;\n    background: orange;\n  }\n\n  .graph-explorer-badge {\n    display: none;\n    margin-left: .5em;\n    white-space: normal;\n    word-wrap: normal;\n  }\n\n  .link-title {\n    font-size: 16px;\n    color: black;\n    display: inline;\n  }\n\n  .graph-explorer-btn-group {\n    float: left;\n    margin-top: 2px;\n    margin-right: 6px;\n    margin-bottom: 2px;\n  }\n\n  .graph-explorer-btn.graph-explorer-btn-default {\n    border-color: rgb(195, 195, 195);\n  }\n\n  &__filter-button {\n    display: none;\n    float: right;\n    background-image: url(\"../images/add-to-filter.png\");\n    background-size: 20px 20px;\n    width: 20px;\n    height: 20px;\n    margin: 3px;\n    cursor: pointer;\n    opacity: 0.4;\n    transition: opacity 200ms 0ms;\n  }\n  &:hover &__filter-button {\n    opacity: 1.0;\n    transition: opacity 200ms 0ms;\n  }\n}\n\n.connected-links .linkInToolBox .graph-explorer-badge {\n  /* show connection count badge only in \"Connected to Element\" list */\n  display: inline;\n}\n.connected-links .linkInToolBox__filter-button {\n  /* show filter button only in \"Connected to Element\" list */\n  display: inline;\n}\n",".graph-explorer-list-element-view {\n  position: relative;\n  display: block;\n  background: #808080;\n  padding: 1px 1px 1px 10px;\n  border-radius: 2px;\n  margin: 0 0 2px 0;\n  opacity: 1.0;\n  cursor: move;\n  user-select: none;\n\n  &--disabled {\n    opacity: 0.4;\n    cursor: default;\n  }\n\n  &__label {\n    background: white;\n    border-radius: 0 2px 2px 0;\n    font-family: \"Andale Mono\", sans-serif;\n    font-size: 15px;\n    min-height: 1.3em;\n    padding-left: 7px;\n    padding-right: 5px;\n    overflow-wrap: break-word;\n  }\n}\n\n.graph-explorer-text-highlight {\n  font-weight: bold;\n}\n",".graph-explorer-navigator {\n  display: block;\n  position: absolute;\n  bottom: 25px;\n  right: 25px;\n  overflow: hidden;\n\n  // increase specificity to override default box-sizing,\n  // so border size won't be included into total size\n  .graph-explorer & {\n    box-sizing: content-box;\n  }\n\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n\n  $transition: 0.3s;\n  transition: width $transition, height $transition;\n\n  &--collapsed {\n    width: 26px;\n    height: 26px;\n  }\n\n  > canvas {\n    transition: opacity $transition;\n  }\n  &--expanded > canvas { opacity: 1; }\n  &--collapsed > canvas { opacity: 0; }\n\n  &__toggle {\n    position: absolute;\n    background: transparent;\n    border: none;\n    outline: none;\n    padding: 4px;\n\n    opacity: 0.5;\n    transition: opacity 0.3s;\n\n    &:hover {\n      // background: lightgray;\n      opacity: 1;\n    }\n  }\n  &--expanded &__toggle {\n    top: 5px;\n    left: 5px;\n  }\n  &--collapsed &__toggle {\n    top: 0px;\n    left: 0px;\n  }\n\n  &__toggle-icon {\n    width: 18px;\n    height: 18px;\n    background-size: 18px 18px;\n    background-repeat: no-repeat;\n  }\n  &--expanded &__toggle-icon {\n    background-image: url('../images/font-awesome/minus-square-regular.svg');\n  }\n  &--collapsed &__toggle-icon {\n    background-image: url('../images/font-awesome/plus-square-regular.svg');\n  }\n}\n","@keyframes graph-explorer-progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n\n.graph-explorer-progress-bar {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n  width: 100%;\n\n  background-color: #f5f5f5;\n  background-image: linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%);\n  background-repeat: repeat-x;\n  overflow: hidden;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n\n  &__bar {\n    float: left;\n    height: 100%;\n    font-size: 12px;\n    line-height: 20px;\n    color: #fff;\n    text-align: center;\n    transition: width .6s ease;\n\n    background-color: #337ab7;\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n    background-repeat: repeat-x;\n    background-size: 40px 40px;\n\n    animation: graph-explorer-progress-bar-stripes 2s linear infinite;\n  }\n\n  &--error &__bar {\n    background-color: #E72F2F;\n  }\n\n  &--loading,\n  &--error {\n    /* property name | duration | delay */\n    transition: height 300ms 300ms;\n  }\n\n  &--completed {\n    /* property name | duration | delay */\n    transition: height 200ms 0ms;\n  }\n}\n",".graph-explorer-search-results {\n  margin: 0;\n  padding: 0;\n  outline: none;\n}\n",".graph-explorer-accordion {\n  flex: auto;\n  display: flex;\n  height: 100%;\n  width: 100%;\n\n  &--scrollable {\n    overflow: auto;\n  }\n\n  &--vertical {\n    flex-direction: column;\n  }\n\n  &--vertical:not(&--resizing) > .graph-explorer-accordion-item {\n    transition: height 0.3s ease-in-out;\n  }\n}\n\n.graph-explorer-accordion-item {\n  display: flex;\n  position: relative;\n  flex: auto;\n\n  &--resizing > &__handle, &__handle:hover {\n    background: rgba(0, 0, 0, 0.1);\n  }\n\n  &--vertical {\n    border-top: 1px solid lightgray;\n\n    &:first-child {\n      border-top-width: 0;\n    }\n  }\n\n  &--horizontal {\n    border-right: 1px solid lightgray;\n\n    &:last-child {\n      border-right-width: 0;\n    }\n  }\n\n  &__handle {\n    position: absolute;\n    z-index: 2;\n  }\n\n  &__handle-vertical {\n    height: 5px;\n    bottom: -2.5px;\n    left: 0;\n    width: 100%;\n    cursor: ns-resize;\n  }\n\n  &__handle-horizontal {\n    height: 100%;\n    top: 0;\n    right: -2.5px;\n    width: 5px;\n    cursor: ew-resize;\n  }\n\n  &__handle-btn {\n    background: #fff;\n    border: 2px solid #17b;\n    box-shadow: 0 0 0 1px rgba(9, 30, 66, 0.08), 0 2px 4px 1px rgba(9, 30, 66, 0.08);\n    border-radius: 10px;\n    cursor: pointer;\n    height: 20px;\n    position: absolute;\n    top: 50%;\n    margin-top: -10px;\n    width: 20px;\n    z-index: 20;\n    transition: 0.3s;\n\n    &::before {\n      background-position: 0 0;\n      background-repeat: no-repeat;\n      background-size: cover;\n      content: \"\";\n      height: 8px;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -4px;\n      margin-left: -4px;\n      width: 8px;\n      transition: background 0.3s;\n    }\n\n    &:hover {\n      background: #17b;\n    }\n  }\n\n  &__handle-btn-left {\n    left: 100%;\n    margin-left: -10px;\n    &:before { background-image: url(\"../images/arrow-left.png\"); }\n    &:hover:before { background-image: url(\"../images/arrow-left1.png\"); }\n  }\n\n  &__handle-btn-right {\n    right: 100%;\n    margin-right: -10px;\n    &:before { background-image: url(\"../images/arrow-right.png\"); }\n    &:hover:before { background-image: url(\"../images/arrow-right1.png\"); }\n  }\n\n  &--collapsed &__handle-btn:before {\n    transform: rotate(180deg);\n  }\n\n  &__inner {\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  &__body {\n    flex: 1 1 0px; // IE 11 requires a unit to be added to the third argument\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__header {\n    padding-left: 20px;\n    position: relative;\n\n    flex-shrink: 0;\n    font-size: 16px;\n    background: #E4E4E4;\n    cursor: default;\n    /* unselectable */\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    &:before {\n      border-top: 6px solid #555555;\n      border-left: 3.5px solid transparent;\n      border-right: 3.5px solid transparent;\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 7px;\n      margin-top: -3px;\n\n      -webkit-transition: 0.1s;\n      -moz-transition: 0.1s;\n      transition: 0.1s;\n    }\n  }\n\n  &--collapsed &__header:before {\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n  }\n\n  &--collapsed &__body {\n    display: none;\n  }\n}\n",".graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-bottom,\n.graph-explorer-drag-resizable-column.graph-explorer-drag-resizable-column--docked-top {\n  .graph-explorer-drag-resizable-column__handle {\n    height: 8px;\n    width: 100%;\n    top: initial;\n    left: 0;\n    cursor: ns-resize;\n  }\n\n  .graph-explorer-drag-resizable-column__handle-btn {\n    height: 100%;\n    width: 40px;\n    top: 0;\n    left: 50%;\n    margin-left: -20px;\n    margin-top: 0px;\n  }\n}\n\n.graph-explorer-drag-resizable-column {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  &__handle {\n    background: #fff url(\"../images/resizable-column-handle.png\") repeat;\n    width: 8px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: initial;\n    z-index: 2;\n    -webkit-transition: 0.3s;\n    -moz-transition: 0.3s;\n    transition: 0.3s;\n    cursor: ew-resize;\n  }\n\n  &__handle-btn {\n    background: #eee;\n    cursor: pointer;\n    height: 40px;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    margin-top: -20px;\n    width: 100%;\n    z-index: 1;\n    -webkit-transition: 0.3s;\n    -moz-transition: 0.3s;\n    transition: 0.3s;\n\n    &::before {\n      background-position: 0 0 ;\n      background-repeat: no-repeat;\n      background-size: cover;\n      content: \"\";\n      height: 6px;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -3px;\n      margin-left: -3px;\n      width: 6px;\n      -webkit-transition: 0.3s;\n      -moz-transition: 0.3s;\n      transition: 0.3s;\n    }\n\n    &:hover {\n      background: #b3b3b3;\n      transform: scale(1.2);\n    }\n  }\n\n  &--closed &__handle-btn {\n    &::before { transform: rotate(180deg); }\n  }\n\n  &--docked-left { margin-right: 8px; }\n  &--docked-left &__handle { right: -8px; }\n  &--docked-left &__handle-btn {\n    &::before { background-image: url(\"../images/arrow-left.png\"); }\n    &:hover::before { background-image: url(\"../images/arrow-left1.png\"); }\n  }\n\n  &--docked-right { margin-left: 8px; }\n  &--docked-right &__handle { left: -8px; }\n  &--docked-right &__handle-btn {\n    &::before { background-image: url(\"../images/arrow-right.png\"); }\n    &:hover::before { background-image: url(\"../images/arrow-right1.png\"); }\n  }\n\n  &--docked-top { margin-bottom: 8px; }\n  &--docked-top &__handle { bottom: -8px; }\n  &--docked-top &__handle-btn {\n    &::before { background-image: url(\"../images/arrow-top.png\"); }\n    &:hover::before { background-image: url(\"../images/arrow-top1.png\"); }\n  }\n\n  &--docked-bottom { margin-top: 8px; }\n  &--docked-bottom &__handle { top: -8px; }\n  &--docked-bottom &__handle-btn {\n    &::before { background-image: url(\"../images/arrow-bottom.png\"); }\n    &:hover::before { background-image: url(\"../images/arrow-bottom1.png\"); }\n  }\n}\n",".introjs-tooltiptext {\n  color: #333;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n","$toolbarHeight: 30px;\n\n.graph-explorer-toolbar {\n  &__language-selector {\n    margin-left: 5px;\n    margin-right: 5px;\n\n    > label {\n      margin-right: 5px;\n      > span { vertical-align: middle; }\n    }\n\n    > select {\n      height: $toolbarHeight;\n    }\n  }\n\n  &__toggle {\n    line-height: 1;\n  }\n\n  &__toggle:after {\n    background-position: 0 0;\n    background-repeat: no-repeat;\n    content: '';\n    display: block;\n    height: 12px;\n    margin: 3px 0;\n    width: 12px;\n  }\n\n  &__toggle-left:after {\n    background-image: url('../images/left-panel.svg');\n  }\n\n  &__toggle-right:after {\n    background-image: url('../images/right-panel.svg');\n  }\n\n  &__toggle.active {\n    border-color: #c3c3c3;\n  }\n\n  &__toggle-left.active:after {\n    background-image: url('../images/left-panel-active.svg');\n  }\n\n  &__toggle-right.active:after {\n    background-image: url('../images/right-panel-active.svg');\n  }\n\n  &__layout-group {\n    float: left;\n    margin-left: 5px;\n    height: $toolbarHeight;\n\n    > label {\n      margin-right: 5px;\n    }\n\n    .btn-group,button {\n      height: 100%;\n    }\n  }\n}\n\n.graph-explorer-toolbar .graph-explorer-toolbar__undo,\n.graph-explorer-toolbar .graph-explorer-toolbar__redo {\n  display: none;\n}\n\n",".graph-explorer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  // defaults for inheritable properties\n  box-sizing: border-box;\n  white-space: initial;\n  color: #333;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n  &__toolbar-widget {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n  }\n\n  &__workspace {\n    display: flex;\n    flex: auto;\n    overflow: hidden;\n    flex-direction: column;\n  }\n\n  &__main-panel {\n    display: flex;\n    flex: auto;\n    overflow: hidden;\n    width: 0;\n  }\n\n  &--unselectable {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  &--horizontal-resizing * { cursor: ew-resize !important; }\n  &--vertical-resizing * { cursor: ns-resize !important; }\n\n  h4 {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 1.1;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n\n  select {\n    color: inherit;\n    margin: 0;\n    font: inherit;\n    line-height: inherit;\n    text-transform: none;\n  }\n\n  hr {\n    border: 0;\n    border-top: 1px solid #eee;\n    height: 0;\n  }\n}\n\n.graph-explorer-scrollable {\n  flex: 1 1 0px; // IE 11 requires a unit to be added to the third argument\n  overflow-y: scroll;\n}\n\n// fixes the bug in Chrome with redrawing children in scrollable elements\n.graph-explorer-scrollable > * {\n  position: relative;\n}\n",".jstree-icon.jstree-themeicon.jstree-themeicon-custom {\n  background-size: contain !important; // HACK: override background-size to fit in custom icons\n}\n",".graph-explorer-default-template {\n  max-width: 450px;\n  float: left;\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 1px;\n\n  &__thumbnail {\n    text-align: center;\n    > img {\n      max-width: 200px;\n    }\n  }\n\n  &[data-expanded='true'] &__thumbnail > img {\n    max-width: 350px;\n  }\n}\n\n.graph-explorer-default-template_type-line {\n  padding: 0px 7px;\n  color: white;\n  height: 18px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  display: flex;\n  align-items: baseline;\n  margin-top: -3px;\n}\n\ndiv.graph-explorer-default-template_type-line__icon {\n  position: inherit !important;\n  margin-right: 4px;\n}\n\n.graph-explorer-default-template_type-line_text-container {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 0;\n}\n.graph-explorer-default-template_type-line_text-container__text {\n  display: inline;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.graph-explorer-default-template_body {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  background: white;\n  padding: 7px 10px 8px 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-explorer-default-template_body__label {\n  font-size: 19px;\n  font-weight: 100;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0;\n  white-space: nowrap;\n  word-wrap: break-word;\n}\n\n.graph-explorer-default-template_body_expander {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n\n.graph-explorer-default-template_body_expander__iri_label {\n  font-size: 12px;\n  font-weight: 100;\n  margin-right: 15px;\n  color: #b6b6b6;\n}\n\n.graph-explorer-default-template_body_expander_iri {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.graph-explorer-default-template_body_expander_iri__link {\n  color: #b6b6b6;\n}\n\n.graph-explorer-default-template_body_expander__hr {\n  margin: 5px 0px 5px 0px;\n}\n\n.graph-explorer-default-template_body_expander_property-table {\n  font-size: 15px;\n  font-weight: 100;\n  margin-bottom: 5px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row {\n  white-space: nowrap;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row__key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row_key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row_key_values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.graph-explorer-default-template_body_expander_property-table_row_key_values__value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n","@use \"./defaultElement\";\n\n.graph-explorer-group-template {\n  overflow: hidden;\n\n  &__wrap {\n    @extend .graph-explorer-default-template;\n    max-width: none;\n  }\n\n  &__type-line {\n    @extend .graph-explorer-default-template_type-line;\n  }\n\n  &__type-line-icon {\n    @extend .graph-explorer-default-template_type-line__icon;\n  }\n\n  &__type-line-text-container {\n    @extend .graph-explorer-default-template_type-line_text-container;\n  }\n\n  &__type-line-text {\n    @extend .graph-explorer-default-template_type-line_text-container__text;\n  }\n\n  &__body {\n    @extend .graph-explorer-default-template_body;\n    overflow: visible;\n  }\n\n  &__label {\n    @extend .graph-explorer-default-template_body__label;\n  }\n\n  &__embedded-layer {\n    margin-top: 7px;\n  }\n\n  .graph-explorer-paper__canvas {\n    border-color: #fff;\n  }\n}\n",".graph-explorer-standard-template {\n  min-width: 180px;\n  max-width: 400px;\n  float: left;\n\n  &__main {\n    border-radius: 2px;\n    border: 1px solid;\n  }\n\n  &__body {\n    margin-left: 8px;\n    border-radius: 0 2px 2px 0;\n    border-left: 1px solid;\n    padding: 3px 0;\n    background: #fafaf9;\n  }\n\n  &__body-horizontal {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    overflow: hidden;\n  }\n\n  &__body-content {\n    flex-grow: 1;\n    min-width: 0;\n    margin-right: 12px;\n  }\n\n  &__label {\n    font-size: 19px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__thumbnail {\n    font-size: 26px;\n    margin: 5px 10px;\n    flex-shrink: 0;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__thumbnail-image {\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  &__thumbnail-icon {\n    max-height: 26px;\n    max-width: 26px;\n  }\n\n  &__photo {\n    border-bottom: 1px solid;\n  }\n\n  &__photo-image {\n    width: 100%;\n    border-radius: 2px 2px 0 0;\n  }\n\n  &__type {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 11px;\n    font-style: italic;\n    color: #999;\n    display: flex;\n  }\n\n  &__type-value {\n    width: 0;\n    flex-grow: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__iri {\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n  }\n\n  &__iri-key {\n    font-size: 12px;\n    margin-right: 4px;\n    color: #b6b6b6;\n  }\n\n  &__iri-value {\n    font-size: 12px;\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  &__iri-value a {\n    color: #b6b6b6;\n  }\n\n  &__hr {\n    margin: 5px 0;\n  }\n\n  &__properties {\n    font-size: 15px;\n    max-height: 200px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n\n  &__propertites-row {\n    white-space: nowrap;\n  }\n\n  &__properties-key {\n    display: inline-block;\n    width: 50%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    vertical-align: top;\n  }\n\n  &__properties-values {\n    display: inline-block;\n    width: 50%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  &__properties-value {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: initial;\n    padding-right: 10px;\n  }\n\n  &__pinned-props {\n    border-top: 1px solid;\n    margin: 0 5px;\n  }\n\n  &__dropdown {\n    border-radius: 2px;\n    background-color: white;\n    margin-top: 5px;\n    border: 1px solid;\n  }\n\n  &__dropdown-content {\n    width: 100%;\n    padding: 9px;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: space-between;\n    button {\n      padding: 5px;\n      min-width: 60px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
